<!-- Firm Profile Component -->
<div class="table-responsive-wrapper">
<ng-container *ngIf="isLauditor">
  <!-- Profile Completion Banner -->
  <div class="profile-completion-banner" 
       *ngIf="showProfileBanner && !isEditPersonalInfo && !isEditAdditionalInfo && !isPhotoModalOpen">
    <div class="completion-left">
      <div class="progress-circle">{{profileCompletionPercentage}}%</div>
      <div class="completion-text-group">
        <!-- <div class="completion-title">Profile cannot go live if incomplete</div> -->
         <div class="completion-title">
      {{ profileCompletionPercentage >= 50 
        ? 'Please complete your profile to stand out and get discovered by more clients.' 
        : 'Profile cannot go live if incomplete' }}
    </div>
        <a class="complete-now-link" (click)="handleCompleteNow()">Complete Now</a>
      </div>
    </div>
    <button class="close-banner" (click)="dismissProfileBanner()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- Marketplace visibility alert -->
  <!-- <div class="marketplace-alert-banner" *ngIf="!isMarketplaceListed">
    <i class="fas fa-info-circle marketplace-alert-icon"></i>
    <span class="marketplace-alert-text">
      You're currently unavailable for new consultations. Turn on
      <a class="marketplace-alert-link" (click)="scrollToMarketplaceToggle()">Available for Consultations</a>
      to receive new consultation requests and appear in client search results.
    </span>
  </div> -->

  <!-- ========================================
       PERSONAL INFO SECTION
       ======================================== -->
  <div class="personal-info-card">
    <div class="card-content-wrapper">
      
      <!-- Profile Image Section -->
      <!-- ───── SET PROFILE PHOTO MODAL (single guided workflow) ───── -->
<div *ngIf="isPhotoModalOpen" class="photo-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="setProfilePhotoTitle">
  <div class="photo-modal-dialog">

    <!-- Header (shared by both steps) -->
    <div class="wa-topbar">
      <ng-container *ngIf="photoModalStep === 'crop'; else waDefaultTopbar">
        <span class="wa-topbar-title wa-topbar-title-left">Crop &amp; Adjust Photo</span>
        <div class="wa-topbar-right-group">
          <button type="button" class="wa-topbar-link wa-topbar-link-secondary" (click)="triggerFileInput()">Upload New</button>
          <button type="button" class="wa-topbar-close" (click)="closePhotoModal()" aria-label="Close">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </ng-container>
      <ng-template #waDefaultTopbar>
        <span class="wa-topbar-title" id="setProfilePhotoTitle">Set Profile Photo</span>
        <button type="button" class="wa-topbar-close" (click)="closePhotoModal()" aria-label="Close">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </ng-template>
    </div>

    <!-- STEP 1: Photo selection screen -->
    <ng-container *ngIf="photoModalStep === 'select'">
      <div class="photo-modal-body">
        <div class="photo-modal-preview-wrap">
          <ng-container *ngIf="(modalPreviewUrl || profilePictureUrl); else modalInitialsBlock">
            <img [src]="modalPreviewUrl || profilePictureUrl" class="photo-modal-preview-img" alt="Profile picture preview" />
          </ng-container>
          <ng-template #modalInitialsBlock>
            <div class="photo-modal-preview-initials">
              {{ (isFirmProfileView || isAAM) ? getFirmInitial() : getUserInitial() }}
            </div>
          </ng-template>
        </div>

        <button type="button" class="photo-modal-upload-btn" (click)="triggerFileInput()">
          <i class="fa fa-camera" aria-hidden="true"></i> Upload New Photo
        </button>

        <button type="button" class="photo-modal-remove-btn"
                *ngIf="profilePictureUrl && !hasPendingPhoto"
                (click)="removeProfilePicture()">
          <i class="fa fa-trash" aria-hidden="true"></i> Remove Photo
        </button>
      </div>

      <div class="wa-action-row">
        <button type="button" class="wa-btn-cancel" (click)="closePhotoModal()">
          <i class="fa fa-times" aria-hidden="true"></i> Cancel
        </button>
      </div>
    </ng-container>

    <!-- STEP 2: Crop / reposition screen -->
    <ng-container *ngIf="photoModalStep === 'crop'">
      <div class="wa-crop-wrap"
           (mousedown)="startDrag($event)"
           (mousemove)="onDrag($event)"
           (mouseup)="stopDrag()"
           (mouseleave)="stopDrag()"
           (touchstart)="startDragTouch($event)"
           (touchmove)="onDragTouch($event)"
           (touchend)="stopDrag()"
           (wheel)="onWheel($event)">
        <img [src]="modalPreviewUrl"
             [style.transform]="adjustTransform"
             class="wa-crop-img"
             draggable="false"
             alt="Adjust photo" />
      </div>

      <p class="wa-hint-text">Pinch or scroll to zoom · Drag to reposition</p>

      <div class="wa-zoom-row">
        <button type="button" class="wa-zoom-icon-btn" (click)="onZoomChange(adjustScale - 0.25)" aria-label="Zoom out">
          <i class="fa fa-search-minus" aria-hidden="true"></i>
        </button>
        <input type="range" min="1" max="3" step="0.01"
               [ngModel]="adjustScale"
               (ngModelChange)="onZoomChange($event)"
               class="wa-zoom-slider"
               aria-label="Zoom" />
        <button type="button" class="wa-zoom-icon-btn" (click)="onZoomChange(adjustScale + 0.25)" aria-label="Zoom in">
          <i class="fa fa-search-plus" aria-hidden="true"></i>
        </button>
      </div>

      <div class="wa-rotate-row">
        <button type="button" class="wa-rotate-btn" (click)="rotateCCW()">
          <i class="fa fa-undo" aria-hidden="true"></i> Rotate left
        </button>
        <button type="button" class="wa-rotate-btn" (click)="rotateCW()">
          <i class="fa fa-repeat" aria-hidden="true"></i> Rotate right
        </button>
      </div>

      <div class="wa-action-row">
        <button type="button" class="wa-btn-cancel" (click)="backToSelect()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
        <button type="button" class="wa-btn-save" (click)="saveAdjust()">
          <i class="fa fa-check" aria-hidden="true"></i> Save
        </button>
      </div>
    </ng-container>

  </div>
</div>

<!-- ───── NORMAL PROFILE IMAGE SECTION (WhatsApp Web style avatar interaction) ───── -->
<div class="profile-image-section">
  <div class="wa-avatar-wrap" id="profileAvatarWrap" [class.wa-avatar-highlight]="highlightAvatar">
    <div class="profile-photo-container" (click)="onAvatarClick($event)">
      <ng-container *ngIf="profilePictureUrl; else initialsBlock">
        <img [src]="profilePictureUrl"
             class="profile-image-view"
             alt="Profile picture"
             loading="lazy" />
      </ng-container>
      <ng-template #initialsBlock>
        <div class="initials-view">
          {{ (isFirmProfileView || isAAM) ? getFirmInitial() : getUserInitial() }}
        </div>
      </ng-template>

      <!-- Hover overlay (WhatsApp-style) -->
      <div class="wa-avatar-hover-overlay">
        <i class="fa fa-camera" aria-hidden="true"></i>
        <span>{{ profilePictureUrl ? 'Change Profile Photo' : 'Add Profile Photo' }}</span>
      </div>
    </div>

    <!-- Bottom-right floating edit icon -->
    <button type="button" class="wa-avatar-edit-fab" (click)="onAvatarClick($event)" aria-label="Edit profile photo" title="Edit profile photo">
      <i class="fa fa-pencil" aria-hidden="true"></i>
    </button>

    <!-- Inline hint bubble (Complete Now prompt) — dismissed on first avatar click -->
    <div class="wa-avatar-hint" *ngIf="showAvatarHint">
      Click here to add your photo
    </div>

    <!-- Contextual dropdown menu, anchored beside the avatar -->
    <ng-container *ngIf="showAvatarMenu">
      <div class="wa-avatar-menu-backdrop" (click)="closeAvatarMenu()"></div>
      <div class="wa-avatar-menu" role="menu">
        <button type="button" class="wa-avatar-menu-item" role="menuitem" (click)="onUploadNewPhotoClick()">
          <i class="fa fa-upload" aria-hidden="true"></i> Upload New Photo
        </button>
        <button type="button" class="wa-avatar-menu-item wa-avatar-menu-item-danger" role="menuitem"
                *ngIf="profilePictureUrl"
                (click)="onRemovePhotoClick()">
          <i class="fa fa-trash" aria-hidden="true"></i> Remove Photo
        </button>
      </div>
    </ng-container>
  </div>

  <input type="file"
         id="profilePictureInput"
         accept="image/jpeg,image/png,image/webp"
         style="display: none;"
         (change)="onProfilePictureSelect($event)" />
</div>

<!-- ───── Remove Photo confirmation dialog ───── -->
<div class="wa-confirm-overlay" *ngIf="showRemoveConfirm" role="dialog" aria-modal="true" aria-labelledby="removePhotoConfirmTitle">
  <div class="wa-confirm-dialog">
    <h4 class="wa-confirm-title" id="removePhotoConfirmTitle">Remove Profile Photo?</h4>
    <p class="wa-confirm-message">Are you sure you want to remove your profile picture?</p>
    <div class="wa-confirm-actions">
      <button type="button" class="wa-btn-cancel" (click)="cancelRemovePhoto()">Cancel</button>
      <button type="button" class="wa-btn-remove" (click)="confirmRemovePhoto()">Remove</button>
    </div>
  </div>
</div>
      
      <!-- Personal Information Section -->
      <div class="personal-info-section">
        <div class="section-header-flex">
          <h3 class="section-heading">{{ isFirmProfileView || isAAM ? 'Firm Information' : 'Profile Information' }}</h3>
          <button *ngIf="!isEditPersonalInfo" class="edit-section-btn" (click)="editPersonalInfo()">
            <i class="fa fa-edit"></i> Edit
          </button>
        </div>
        

      <!-- VIEW MODE -->
<div *ngIf="!isEditPersonalInfo">

  <!-- ENTITY CATEGORY -->
  <div *ngIf="!isSoloCategory">

    <!-- ROW 1 -->
    <div class="info-row">
      <div class="info-field">
        <label class="field-label-view">Firm Name</label>
        <div class="field-value-view">{{ firm_details?.fullname }}</div>
      </div>
      <div class="info-field">
        <!-- TM/GH see "Name" (from profile.name); others see "Contact Name" -->
        <label class="field-label-view"> {{ (isFirmProfileView) ? 'Contact Name' : 'Name' }}</label>
        <div class="field-value-view">{{ (isFirmProfileView || isAAM) ? (firm_details?.contact_person || 'N/A') : (basic_profile?.name) }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Email</label>
        <div class="field-value-view">{{ (isFirmProfileView || isAAM) ? (firm_details?.email || 'N/A') : (basic_profile?.email || 'N/A') }}</div>
      </div>
    </div>

    <!-- ROW 2 -->
    <!-- Firm Profile (SU) / AAM: Gender removed; Website moved up here -->
    <div class="info-row" *ngIf="isFirmProfileView || isAAM">
      <div class="info-field">
        <label class="field-label-view">Phone Number</label>
        <div class="field-value-view">{{ firm_details?.contact_phone || 'N/A' }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Country</label>
        <div class="field-value-view">India</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Website</label>
        <div class="field-value-view">
          <a *ngIf="firm_details?.website" class="website-link"
             [href]="firm_details.website.startsWith('http') ? firm_details.website : 'https://' + firm_details.website"
             target="_blank" rel="noopener noreferrer">{{ firm_details.website }}</a>
          <span *ngIf="!firm_details?.website">N/A</span>
        </div>
      </div>
    </div>

    <!-- My Profile / Profile Information (non-firm, non-AAM): unchanged -->
    <div class="info-row" *ngIf="!(isFirmProfileView || isAAM)">
      <div class="info-field">
        <label class="field-label-view">Phone Number</label>
        <div class="field-value-view">{{ basic_profile?.mobile || 'N/A' }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Gender</label>
        <div class="field-value-view">{{ basic_profile?.gender || 'N/A' }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Country</label>
        <div class="field-value-view">India</div>
      </div>
    </div>

    <!-- ROW 3 -->
    <!-- <div class="info-row">
      <!-- Consultation Fee: hidden only for AAM and SU firm profile context; visible for SU My Profile --
      <div class="info-field" *ngIf="!isAAM && !isFirmProfileView">
        <label class="field-label-view">Consultation Fee</label>
        <div class="field-value-view">{{ basic_profile?.consultation_fee?.symbol }}{{ basic_profile?.consultation_fee?.amount || 'N/A' }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Nationality</label>
        <div class="field-value-view">Indian</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Website</label>
        <div class="field-value-view">
          <a *ngIf="firm_details?.website" class="website-link"
             [href]="firm_details.website.startsWith('http') ? firm_details.website : 'https://' + firm_details.website"
             target="_blank" rel="noopener noreferrer">{{ firm_details.website }}</a>
          <span *ngIf="!firm_details?.website">N/A</span>
        </div>
      </div>
    </div> -->

    <!-- ROW 3: Firm Profile (SU) / AAM: About the Firm, full width -->
    <div class="info-row-bio" *ngIf="isFirmProfileView || isAAM">
      <div class="info-field bio-field-view">
        <label class="field-label-view">About the Firm</label>
        <div class="bio-card">
          <div class="bio-text" [ngClass]="{'bio-collapsed': !isBioExpanded && shouldShowReadMore()}">
            {{ firm_details?.firm_description || 'N/A' }}
          </div>
          <button *ngIf="shouldShowReadMore()" class="read-more-btn" (click)="toggleBio()">
            {{ isBioExpanded ? 'Read Less' : 'Read More' }}
            <i class="fa" [ngClass]="isBioExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ROW 4: My Profile / Profile Information (non-firm, non-AAM): Website (1 col) + Bio (2 col), unchanged -->
    <div class="info-row2" *ngIf="!(isFirmProfileView || isAAM)">
      <div class="info-field">
        <label class="field-label-view">Website</label>
        <div class="field-value-view">
          <a *ngIf="firm_details?.website" class="website-link"
             [href]="firm_details.website.startsWith('http') ? firm_details.website : 'https://' + firm_details.website"
             target="_blank" rel="noopener noreferrer">{{ firm_details.website }}</a>
          <span *ngIf="!firm_details?.website">N/A</span>
        </div>
      </div>
      <div class="info-field bio-field2">
        <label class="field-label-view">Bio</label>
        <div class="bio-card">
          <div class="bio-text" [ngClass]="{'bio-collapsed': !isBioExpanded && shouldShowReadMore()}">
            {{ basic_profile?.bio_description || 'N/A' }}
          </div>
          <button *ngIf="shouldShowReadMore()" class="read-more-btn" (click)="toggleBio()">
            {{ isBioExpanded ? 'Read Less' : 'Read More' }}
            <i class="fa" [ngClass]="isBioExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- SOLO CATEGORY -->
  <div *ngIf="isSoloCategory">

    <!-- ROW 1 -->
    <div class="info-row">
      <div class="info-field">
        <label class="field-label-view">
          {{ (isFirmProfileView) ? 'Contact Name' : 'Name' }}
         </label>
        <div class="field-value-view">{{ basic_profile?.name }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Email</label>
        <div class="field-value-view">{{ (isFirmProfileView || isAAM) ? (firm_details?.email || 'N/A') : (basic_profile?.email || 'N/A') }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Phone Number</label>
        <div class="field-value-view">{{ basic_profile?.mobile }}</div>
      </div>
      <!-- <div class="info-field">
        <label class="field-label-view">Country</label>
        <div class="field-value-view">{{ firm_details?.address?.country }}</div>
      </div> -->
    </div>

    <!-- ROW 2 -->
    <!-- <div class="info-row"> -->
      
      <!-- <div class="info-field">
        <label class="field-label-view">Billing Currency</label>
        <div class="field-value-view">{{ firm_details?.billing_currency }}</div>
      </div> -->
      <!-- <div class="info-field">
        <label class="field-label-view">Consultation Fee</label>
        <div class="field-value-view">{{ basic_profile?.consultation_fee?.symbol }}{{ basic_profile?.consultation_fee?.amount || 'N/A' }}</div>
      </div> -->
      
    <!-- </div> -->

    <!-- ROW 3 -->
    <div class="info-row">
      <div class="info-field">
        <label class="field-label-view">Country</label>
        <div class="field-value-view">India</div>
      </div>

      <div class="info-field">
        <label class="field-label-view">Date of Birth</label>
        <div class="field-value-view">{{ basic_profile?.date_of_birth }}</div>
      </div>
      <div class="info-field">
        <label class="field-label-view">Gender</label>
        <div class="field-value-view">{{ basic_profile?.gender || 'N/A' }}</div>
      </div>
      <!-- <div class="info-field">
        <label class="field-label-view">Nationality</label>
        <div class="field-value-view">Indian</div>
      </div> -->
      <!-- <div class="info-field">
        <label class="field-label-view">Website</label>
        <div class="field-value-view">
          <a *ngIf="firm_details?.website" class="website-link"
             [href]="firm_details.website.startsWith('http') ? firm_details.website : 'https://' + firm_details.website"
             target="_blank" rel="noopener noreferrer">{{ firm_details.website }}</a>
          <span *ngIf="!firm_details?.website">N/A</span>
        </div>
      </div> -->
      
    </div>

    <!-- ROW 4: Website (1 col) + Bio (2 col) -->
    <div class="info-row2">
      <div class="info-field">
        <label class="field-label-view">Website</label>
        <div class="field-value-view">
          <a *ngIf="firm_details?.website" class="website-link"
             [href]="firm_details.website.startsWith('http') ? firm_details.website : 'https://' + firm_details.website"
             target="_blank" rel="noopener noreferrer">{{ firm_details.website }}</a>
          <span *ngIf="!firm_details?.website">N/A</span>
        </div>
      </div>
      <div class="info-field bio-field2">
        <label class="field-label-view">Bio</label>
        <div class="bio-card">
          <div class="bio-text" [ngClass]="{'bio-collapsed': !isBioExpanded && shouldShowReadMore()}">
            {{ basic_profile?.bio_description || 'N/A' }}
          </div>
          <button *ngIf="shouldShowReadMore()" class="read-more-btn" (click)="toggleBio()">
            {{ isBioExpanded ? 'Read Less' : 'Read More' }}
            <i class="fa" [ngClass]="isBioExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
    </div>


  </div>
</div>

<!-- EDIT MODE -->
<form *ngIf="isEditPersonalInfo" [formGroup]="personalInfoForm">

  <!-- ENTITY CATEGORY -->
  <div *ngIf="!isSoloCategory">

    <!-- ROW 1 -->
    <div class="form-row">
      <div class="form-group">
        <label class="field-label-edit">Firm Name <span class="required-star">*</span></label>
        <!-- TM/GH: Firm Name is read-only -->
        <input type="text" formControlName="fullname" maxlength="30"
               id="field-fullname"
               [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
               [readonly]="isTMorGH"
               placeholder="Enter firm name"/>
        <div *ngIf="!isTMorGH && shouldShowError(personalInfoForm,'fullname')" class="error-text">
          <div *ngIf="personalInfoForm.get('fullname')?.hasError('required')">This field is required</div>
        </div>
      </div>
      <div class="form-group">
        <!-- TM/GH: label is "Name"; others: "Contact Name" -->
        <label class="field-label-edit"> {{ (isFirmProfileView) ? 'Contact Name' : 'Name' }}<span class="required-star">*</span></label>
        <input type="text" formControlName="contact_person" class="form-control-custom"
               id="field-contact_person"
               [placeholder]="isTMorGH ? 'Enter name' : 'Enter contact name'"/>
        <div *ngIf="shouldShowError(personalInfoForm,'contact_person')" class="error-text">
          <div *ngIf="personalInfoForm.get('contact_person')?.hasError('required')">This field is required</div>
        </div>
      </div>
      <div class="form-group">
        <label class="field-label-edit">
          Email <span class="required-star">*</span>
          <i *ngIf="loginIdentifierType === 'email'" class="fa fa-lock field-lock-icon" title="Registered via email — cannot be changed"></i>
        </label>
        <input type="email" formControlName="email"
               [ngClass]="{'form-control-custom': true, 'discountry': loginIdentifierType === 'email'}"
               placeholder="example@example.com"/>
        <div *ngIf="shouldShowError(personalInfoForm,'email')" class="error-text">
        <div *ngIf="personalInfoForm.get('email')?.hasError('required')">This field is required</div>
        <div *ngIf="personalInfoForm.get('email')?.hasError('pattern')">Invalid email format</div>
      </div>
      </div>
    </div>

    <!-- ROW 2 -->
    <!-- Firm Profile (SU) / AAM: Gender removed; Website moved up here -->
    <div class="form-row" *ngIf="isFirmProfileView || isAAM">
      <div class="form-group">
        <label class="field-label-edit">
          Phone Number <span class="required-star">*</span>
          <i *ngIf="loginIdentifierType === 'mobile'" class="fa fa-lock field-lock-icon" title="Registered via mobile — cannot be changed"></i>
        </label>
        <input type="text" formControlName="mobile" maxlength="10"
               (keypress)="loginIdentifierType !== 'mobile' && allowOnlyNumbers($event)"
               [ngClass]="{'form-control-custom': true, 'discountry': loginIdentifierType === 'mobile'}"/>
        <div *ngIf="shouldShowError(personalInfoForm,'mobile')" class="error-text">
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('required')">This field is required</div>
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('pattern')">Enter valid 10-digit number</div>
      </div>
      </div>
      <div class="form-group">
        <label class="field-label-edit">Country</label>
        <select class="form-control-custom discountry" disabled>
          <option selected>India</option>
        </select>
      </div>
      <div class="form-group">
        <label class="field-label-edit">Website</label>
        <input type="text" formControlName="website" id="field-website"
               [ngClass]="{'form-control-custom': true, 'discountry': isWebsiteDisabled, 'input-error': shouldShowError(personalInfoForm,'website')}"
               [readonly]="isWebsiteDisabled"
               [disabled]="isWebsiteDisabled"/>
        <div *ngIf="shouldShowError(personalInfoForm,'website')" class="error-text">
          <div *ngIf="personalInfoForm.get('website')?.hasError('pattern')">Enter a valid website URL (e.g. www.example.com)</div>
        </div>
      </div>
    </div>

    <!-- My Profile / Profile Information (non-firm, non-AAM): unchanged -->
    <div class="form-row" *ngIf="!(isFirmProfileView || isAAM)">
      <div class="form-group">
        <label class="field-label-edit">
          Phone Number <span class="required-star">*</span>
          <i *ngIf="loginIdentifierType === 'mobile'" class="fa fa-lock field-lock-icon" title="Registered via mobile — cannot be changed"></i>
        </label>
        <input type="text" formControlName="mobile" maxlength="10"
               (keypress)="loginIdentifierType !== 'mobile' && allowOnlyNumbers($event)"
               [ngClass]="{'form-control-custom': true, 'discountry': loginIdentifierType === 'mobile'}"/>
        <div *ngIf="shouldShowError(personalInfoForm,'mobile')" class="error-text">
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('required')">This field is required</div>
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('pattern')">Enter valid 10-digit number</div>
      </div>
      </div>
      <div class="form-group">
        <label class="field-label-edit">Gender </label>
        <div class="gender-select-wrapper" [class.open]="isGenderDropdownOpen">
          <div class="gender-select-trigger" (click)="toggleGenderDropdown()">
            <span [ngClass]="{'placeholder-text': !personalInfoForm.get('gender')?.value}">
              {{ selectedGenderLabel || 'Select gender' }}
            </span>
            <i class="fa fa-chevron-down gender-select-arrow"></i>
          </div>
          <div class="gender-select-panel" *ngIf="isGenderDropdownOpen">
            <div class="gender-select-option"
                 *ngFor="let g of genderOptions"
                 [class.selected]="personalInfoForm.get('gender')?.value === g.value"
                 (click)="selectGender(g.value)">
              {{ g.label }}
              <i class="fa fa-check gender-select-check" *ngIf="personalInfoForm.get('gender')?.value === g.value"></i>
            </div>
          </div>
        </div>
        <div *ngIf="shouldShowError(personalInfoForm,'gender')" class="error-text">
        <div *ngIf="personalInfoForm.get('gender')?.hasError('required')">This field is required</div>
      </div>
      </div>
      <div class="form-group">
        <label class="field-label-edit">Country</label>
        <select class="form-control-custom discountry" disabled>
          <option selected>India</option>
        </select>
      </div>
    </div>

    <!-- ROW 3 -->
    <!-- <div class="form-row"> -->
      <!-- Consultation Fee: hidden only for AAM and SU firm profile context; visible for SU My Profile -->
      <!-- <div class="form-group" *ngIf="!isAAM && !isFirmProfileView">
        <label class="field-label-edit">Consultation Fee <span class="required-star">*</span></label>
        <select formControlName="consultation_fee" class="form-control-custom">
          <option value="" disabled>Select fee</option>
          <option *ngFor="let fee of consultationFeeOptions" [value]="fee">{{ fee }}</option>
        </select>
        <div *ngIf="shouldShowError(personalInfoForm,'consultation_fee')" class="error-text">
          <div *ngIf="personalInfoForm.get('consultation_fee')?.hasError('required')">This field is required</div>
        </div>
      </div> -->
      <!-- <div class="form-group">
        <label class="field-label-edit">Nationality <span class="required-star">*</span></label>
        <input type="text" value="Indian" formControlName="nationality" class="form-control-custom discountry" style="cursor:none ! important; focus:none" readonly/>
      </div>
      <div class="form-group">
        <label class="field-label-edit">Website</label>
        <input type="text" formControlName="website" id="field-website"
               [ngClass]="{'form-control-custom': true, 'discountry': isWebsiteDisabled, 'input-error': shouldShowError(personalInfoForm,'website')}"
               [readonly]="isWebsiteDisabled"
               [disabled]="isWebsiteDisabled"/>
        <div *ngIf="shouldShowError(personalInfoForm,'website')" class="error-text">
          <div *ngIf="personalInfoForm.get('website')?.hasError('pattern')">Enter a valid website URL (e.g. www.example.com)</div>
        </div>
      </div> -->
    <!-- </div> -->

    <!-- ROW 4: Firm Profile (SU) / AAM — About the Firm only, full width (Website moved to Row 2) -->
    <div class="info-row-bio" *ngIf="isFirmProfileView || isAAM">
      <div class="form-group bio-field-view">

        <div class="bio-section">
          <label class="field-label-edit">About the Firm</label>

          <textarea formControlName="bio_description" class="form-textarea-custom" id="field-firm_description"
            placeholder="Write about your firm or click 'Summarize Bio' to generate one with AI.">
          </textarea>

          <div class="bio-footer">
            <div class="bio-note">
              <i class="fa fa-info-circle"></i>
              Optional: Use AI to generate a shorter professional bio. You can re-summarize anytime.
            </div>
          
            <button type="button" class="summarize-btn" (click)="getBioSummary()" [disabled]="isBioLoading">
              <img src="assets/img/magicpen.png" class="sort-icon"/>
              {{ isBioLoading ? 'Generating...' : 'Summarize Bio' }}
            </button>
          </div>

         
        </div>

      </div>
    </div>

    <!-- ROW 4: My Profile / Profile Information (non-firm, non-AAM): Website (1 col) + Bio (2 col), unchanged -->
    <div class="form-row2" *ngIf="!(isFirmProfileView || isAAM)">
      <div class="form-group">
        <label class="field-label-edit">Website</label>
        <input type="text" formControlName="website" id="field-website"
               [ngClass]="{'form-control-custom': true, 'discountry': isWebsiteDisabled, 'input-error': shouldShowError(personalInfoForm,'website')}"
               [readonly]="isWebsiteDisabled"
               [disabled]="isWebsiteDisabled"/>
        <div *ngIf="shouldShowError(personalInfoForm,'website')" class="error-text">
          <div *ngIf="personalInfoForm.get('website')?.hasError('pattern')">Enter a valid website URL (e.g. www.example.com)</div>
        </div>
      </div>

      <div class="form-group bio-field2">

        <div class="bio-section">
          <label class="field-label-edit">Bio</label>

          <textarea formControlName="bio_description" class="form-textarea-custom" id="field-bio_description"
            placeholder="Write your professional bio or click 'Summarize Bio' to generate one with AI.">
          </textarea>

          <div class="bio-footer">
            <div class="bio-note">
              <i class="fa fa-info-circle"></i>
              Optional: Use AI to generate a shorter professional bio. You can re-summarize anytime.
            </div>
          
            <button type="button" class="summarize-btn" (click)="getBioSummary()" [disabled]="isBioLoading">
              <img src="assets/img/magicpen.png" class="sort-icon"/>
              {{ isBioLoading ? 'Generating...' : 'Summarize Bio' }}
            </button>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- SOLO CATEGORY -->
  <div *ngIf="isSoloCategory">

    <!-- ROW 1 -->
    <div class="form-row">
      <div class="form-group">
        <label class="field-label-edit"> {{ (isFirmProfileView) ? 'Contact Name' : 'Name' }} <span class="required-star">*</span></label>
        <input type="text" formControlName="contact_person" class="form-control-custom"/>
        <div *ngIf="shouldShowError(personalInfoForm,'contact_person')" class="error-text">
        <div *ngIf="personalInfoForm.get('contact_person')?.hasError('required')">This field is required</div>
      </div>
      </div>
      <div class="form-group">
        <label class="field-label-edit">
          Email 
          <i class="fa fa-lock field-lock-icon" title="Registered via email — cannot be changed"></i>
        </label>
        <input type="email" formControlName="email"
               [ngClass]="{'form-control-custom': true, 'discountry': loginIdentifierType === 'email'}"
               placeholder="example@example.com"/>
        <div *ngIf="shouldShowError(personalInfoForm,'email')" class="error-text">
        <div *ngIf="personalInfoForm.get('email')?.hasError('required')">This field is required</div>
        <div *ngIf="personalInfoForm.get('email')?.hasError('pattern')">Invalid email format</div>
      </div>
      </div>
      <div class="form-group">
        <label class="field-label-edit">
          Phone Number 
          <i class="fa fa-lock field-lock-icon" title="Registered via mobile — cannot be changed"></i>
        </label>
        <input type="text" formControlName="mobile" maxlength="10"
               (keypress)="loginIdentifierType !== 'mobile' && allowOnlyNumbers($event)"
               [ngClass]="{'form-control-custom': true, 'discountry': loginIdentifierType === 'mobile'}"/>
        <div *ngIf="shouldShowError(personalInfoForm,'mobile')" class="error-text">
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('required')">This field is required</div>
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('pattern')">Enter valid 10-digit number</div>
      </div>
      </div>
      <!-- <div class="form-group">
        <label class="field-label-edit">Country <span class="required-star">*</span></label>
        <select formControlName="country" class="form-control-custom discountry">
          <option value="" disabled>Select country</option>
          <option *ngFor="let c of countries" [value]="c[0]">{{ c[0] }}</option>
        </select>
        <div *ngIf="shouldShowError(personalInfoForm,'country')" class="error-text">
        <div *ngIf="personalInfoForm.get('country')?.hasError('required')">This field is required</div>
      </div>
      </div> -->
    </div>

    <!-- ROW 2 -->
    <div class="form-row">
      <!-- <div class="form-group">
        <label class="field-label-edit">
          Phone Number <span class="required-star">*</span>
          <i *ngIf="loginIdentifierType === 'mobile'" class="fa fa-lock field-lock-icon" title="Registered via mobile — cannot be changed"></i>
        </label>
        <input type="text" formControlName="mobile" maxlength="10"
               (keypress)="loginIdentifierType !== 'mobile' && allowOnlyNumbers($event)"
               [ngClass]="{'form-control-custom': true, 'discountry': loginIdentifierType === 'mobile'}"/>
        <div *ngIf="shouldShowError(personalInfoForm,'mobile')" class="error-text">
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('required')">This field is required</div>
        <div *ngIf="personalInfoForm.get('mobile')?.hasError('pattern')">Enter valid 10-digit number</div>
      </div>
      </div> -->
      <!-- <div class="form-group">
        <label class="field-label-edit">Billing Currency <span class="required-star">*</span></label>
        <select formControlName="billing_currency" class="form-control-custom discountry">
          <option value="" disabled>Select currency</option>
          <option *ngFor="let c of currencyList" [value]="c.name">{{ c.name }}</option>
        </select>
        <div *ngIf="shouldShowError(personalInfoForm,'billing_currency')" class="error-text">
        <div *ngIf="personalInfoForm.get('billing_currency')?.hasError('required')">This field is required</div>
      </div>
      </div> -->
      <!-- <div class="form-group">
        <label class="field-label-edit">Consultation Fee <span class="required-star">*</span></label>
        <select formControlName="consultation_fee" class="form-control-custom">
          <option value="" disabled>Select fee</option>
          <option *ngFor="let fee of consultationFeeOptions" [value]="fee">{{ fee }}</option>
        </select>
        <div *ngIf="shouldShowError(personalInfoForm,'consultation_fee')" class="error-text">
          <div *ngIf="personalInfoForm.get('consultation_fee')?.hasError('required')">This field is required</div>
        </div>
      </div> -->

      <div class="form-group">
        <label class="field-label-edit">Country</label>
        <select class="form-control-custom discountry" disabled>
          <option selected>India</option>
        </select>
      </div>

      <div class="form-group">
        <label class="field-label-edit">Date of Birth</label>
       <input
          bsDatepicker
          placeholder="Select"
          formControlName="date_of_birth"
          [bsConfig]="{ dateInputFormat: 'MMM DD, YYYY', showWeekNumbers:false }"
          [maxDate]="today"
          class="form-control-custom"
          readonly
        />
      </div>
      <div class="form-group">
        <label class="field-label-edit">Gender </label>
        <div class="gender-select-wrapper" [class.open]="isGenderDropdownOpen">
          <div class="gender-select-trigger" (click)="toggleGenderDropdown()">
            <span [ngClass]="{'placeholder-text': !personalInfoForm.get('gender')?.value}">
              {{ selectedGenderLabel || 'Select gender' }}
            </span>
            <i class="fa fa-chevron-down gender-select-arrow"></i>
          </div>
          <div class="gender-select-panel" *ngIf="isGenderDropdownOpen">
            <div class="gender-select-option"
                 *ngFor="let g of genderOptions"
                 [class.selected]="personalInfoForm.get('gender')?.value === g.value"
                 (click)="selectGender(g.value)">
              {{ g.label }}
              <i class="fa fa-check gender-select-check" *ngIf="personalInfoForm.get('gender')?.value === g.value"></i>
            </div>
          </div>
        </div>
        <div *ngIf="shouldShowError(personalInfoForm,'gender')" class="error-text">
        <div *ngIf="personalInfoForm.get('gender')?.hasError('required')">This field is required</div>
      </div>
      </div>

    </div>

    <!-- ROW 3 -->
    <div class="form-row2">
      <!-- <div class="form-group">
        <label class="field-label-edit">Date of Birth</label>
       <input
          bsDatepicker
          placeholder="Select"
          formControlName="date_of_birth"
          [bsConfig]="{ dateInputFormat: 'MMM DD, YYYY', showWeekNumbers:false }"
          [maxDate]="today"
          class="form-control-custom"
          readonly
        />
      </div>
      <div class="form-group">
        <label class="field-label-edit">Gender </label>
        <select formControlName="gender" class="form-control-custom">
          <option value="" disabled>Select gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
        <div *ngIf="shouldShowError(personalInfoForm,'gender')" class="error-text">
        <div *ngIf="personalInfoForm.get('gender')?.hasError('required')">This field is required</div>
      </div>
      </div> -->
      <div class="form-group">
        <label class="field-label-edit">Website</label>
        <input type="text" formControlName="website" class="form-control-custom" id="field-website_solo"
               [ngClass]="{'form-control-custom': true, 'input-error': shouldShowError(personalInfoForm,'website')}"/>
        <div *ngIf="shouldShowError(personalInfoForm,'website')" class="error-text">
          <div *ngIf="personalInfoForm.get('website')?.hasError('pattern')">Enter a valid website URL (e.g. www.example.com)</div>
        </div>
      </div>

      <!-- <div class="form-group">
        <label class="field-label-edit">Nationality <span class="required-star">*</span></label>
        <input type="text" value="Indian" formControlName="nationality" class="form-control-custom" readonly/>
      </div> -->

    <!-- ROW 4: Website (1 col) + Bio (2 col) -->
      <div class="form-group solo-layout bio-field2">
        <div class="bio-section">
          <label class="field-label-edit">Bio</label>
        
          <textarea formControlName="bio_description" class="form-textarea-custom"
            placeholder="Write your professional bio or click 'Summarize Bio' to generate one with AI."></textarea>
        
            <div class="bio-footer">
              <span class="bio-note">
                <i class="fa fa-info-circle"></i>
                Optional: Use AI to generate a shorter professional bio. You can re-summarize anytime.
              </span>
            
              <button type="button" class="summarize-btn" (click)="getBioSummary()" [disabled]="isBioLoading">
                <img src="assets/img/magicpen.png" class="sort-icon"/>
                {{ isBioLoading ? 'Generating...' : 'Summarize Bio' }}
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BUTTONS -->
  <div class="btnboxAdd text-center spacebtn">
    <button type="reset" class="btn btn-default btncancel" (click)="cancelPersonalInfo()">Cancel</button>
    <button type="submit" class="btn btn-primary btnsave savecls" (click)="savePersonalInfo()">Save</button>
  </div>

</form>

      </div>
    </div>
  </div>

  <!-- ========================================
       ADDITIONAL INFORMATION SECTION
       ======================================== -->
  <div class="additional-info-card" #additionalSection>
    <div class="section-header-flex">
      <h3 class="section-heading-blue">Additional Information</h3>
    </div>
    
    <!-- Tabs -->
    <div class="extended-tabs">
      <button class="tab-btn" [ngClass]="{'active': activeTab === 'practice'}" (click)="switchTab('practice')">
        Practice Details
      </button>
      <!-- Courts & Cases: only for My Profile (not firm/AAM) -->
      <button *ngIf="!isAAM && !isFirmProfileView" class="tab-btn" [ngClass]="{'active': activeTab === 'courts_cases'}" (click)="switchTab('courts_cases')">
        Courts &amp; Cases
      </button>
      <!-- Education & Awards: hidden for AAM on non-firm views; shown as Awards & Recognitions for firm view / AAM -->
      <button *ngIf="!isAAM && !isFirmProfileView" class="tab-btn" [ngClass]="{'active': activeTab === 'education'}" (click)="switchTab('education')">
        Education & Awards
      </button>
      <button *ngIf="isFirmProfileView || isAAM" class="tab-btn" [ngClass]="{'active': activeTab === 'education'}" (click)="switchTab('education')">
        Awards & Recognitions
      </button>
      <!-- Set Availability: hidden for AAM and hidden for Firm Profile view -->
      <button *ngIf="!isAAM && !isFirmProfileView" class="tab-btn" [ngClass]="{'active': activeTab === 'availability'}" (click)="switchTab('availability')">
        Set Availability
      </button>
      <!-- Subscription Details: visible for Solo (My Profile), Firm Profile view, and AAM; hidden for GH/TM/SU My Profile -->
      <!-- <button *ngIf="(isSoloCategory || isFirmProfileView || isAAM) && (!isEditAdditionalInfo || isAAM)" class="tab-btn"
              [ngClass]="{'active': activeTab === 'subscription'}"
              (click)="switchTab('subscription')"> Subscription Details
      </button> -->
      <!-- Settlement Details: visible for Solo (My Profile), Firm Profile view, and AAM; hidden for GH/TM/SU My Profile -->
      <button *ngIf="(isSoloCategory || isFirmProfileView || isAAM) && (!isEditAdditionalInfo || isAAM)" class="tab-btn"
              [ngClass]="{'active': activeTab === 'settlement'}"
              (click)="switchTab('settlement')"> Settlement Details
      </button>
    </div>
    
    <!-- ========================================
         PRACTICE DETAILS TAB
         ======================================== -->
    <div class="tab-content-area" *ngIf="activeTab === 'practice'">

      <!-- Inner card top-right action bar -->
      <!-- VIEW MODE: Edit button for all roles (non-subscription tab) -->
      <div *ngIf="!isEditAdditionalInfo" class="inner-card-action-bar">
        <button class="edit-section-btn" style='margin-top: -10px;' (click)="editAdditionalInfo()">
          <i class="fa fa-edit"></i> Edit
        </button>
      </div>
      <!-- VIEW MODE -->
      <div *ngIf="!isEditAdditionalInfo">

        <!-- ── PROFESSIONAL INFORMATION SECTION (view) ── -->
        <div class="practice-section-block">
          <div class="practice-section-header">
            <h4 class="practice-section-title">Professional Information</h4>
          </div>
          <div class="prof-info-two-col">
            <!-- LEFT column: Bar Council ID, Billing Currency/Consultation Fee, Languages Spoken -->
            <div class="prof-info-col">
              <!-- Row 1: Bar Council ID + Years of Experience (stacked for Firm/AAM, side-by-side for My Profile) -->
              <div [ngClass]="(isFirmProfileView || isAAM) ? 'prof-info-col-stacked' : 'prof-info-row-pair'">
                <div class="info-field">
                  <label class="field-label-view">{{ (isFirmProfileView || isAAM) ? 'Registration ID' : 'Bar Council ID' }}</label>
                  <div class="field-value-view">{{ (isFirmProfileView || isAAM) ? (firm_details?.reg_id || 'N/A') : (basic_profile?.bar_council_id || 'N/A') }}</div>
                </div>
                <div class="info-field">
                  <label class="field-label-view">{{ (isFirmProfileView || isAAM) ? 'Year of Incorporation' : 'Years of Experience' }}</label>
                  <div class="field-value-view">{{ (isFirmProfileView || isAAM) ? (firm_details?.years_of_incorporation ?? 'N/A') : ((basic_profile?.years_of_experience !== null && basic_profile?.years_of_experience !== undefined) ? basic_profile?.years_of_experience : 'N/A') }}</div>
                </div>
              </div>
              <!-- Row 2: Billing Currency + Consultation Fee (My Profile only) -->
              <div class="prof-info-row-pair" *ngIf="!isFirmProfileView && !isAAM">
                <div class="info-field">
                  <label class="field-label-view">Billing Currency</label>
                  <div class="field-value-view">{{ firm_details?.billing_currency || 'N/A' }}</div>
                </div>
                <div class="info-field">
                  <label class="field-label-view">Consultation Fee</label>
                  <div class="field-value-view">{{ basic_profile?.consultation_fee?.symbol }}{{ basic_profile?.consultation_fee?.amount || 'N/A' }}</div>
                </div>
              </div>
              <!-- Row 3: Languages Spoken (My Profile only) -->
              <div class="practice-list-item" *ngIf="!isFirmProfileView && !isAAM">
                <label class="field-label-view">Languages Spoken</label>
                <div class="tags-container" *ngIf="basic_profile?.languages_spoken?.length">
                  <span class="tag tag-language" *ngFor="let lang of basic_profile.languages_spoken">{{ lang }}</span>
                </div>
                <div class="no-content-text" *ngIf="!basic_profile?.languages_spoken?.length">No languages specified</div>
              </div>
            </div>
            <!-- RIGHT column: Practice Areas, Services Offered -->
            <div class="prof-info-col">
              <div class="practice-list-item">
                <label class="field-label-view">Practice Areas</label>
                <div class="tags-container" *ngIf="(isFirmProfileView || isAAM) ? firm_details?.practice_areas?.length : basic_profile?.practice_areas?.length">
                  <span class="tag" *ngFor="let area of (isFirmProfileView || isAAM) ? firm_details.practice_areas : basic_profile.practice_areas">{{ area }}</span>
                </div>
                <div class="no-content-text" *ngIf="(isFirmProfileView || isAAM) ? !firm_details?.practice_areas?.length : !basic_profile?.practice_areas?.length">No practice areas specified</div>
              </div>
              <div class="practice-list-item">
                <label class="field-label-view">Services Offered</label>
                <div class="tags-container" *ngIf="(isFirmProfileView || isAAM) ? firm_details?.services_offered?.length : basic_profile?.services_offered?.length">
                  <span class="tag tag-service" *ngFor="let service of (isFirmProfileView || isAAM) ? firm_details.services_offered : basic_profile.services_offered">{{ service }}</span>
                </div>
                <div class="no-content-text" *ngIf="(isFirmProfileView || isAAM) ? !firm_details?.services_offered?.length : !basic_profile?.services_offered?.length">No services specified</div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── ADDRESSES SECTION (view) ── -->
        <div class="practice-section-block">
          <div class="practice-section-header" style="margin-top: 10px;">
            <h4 class="practice-section-title">Addresses</h4>
          </div>
          <div class="addresses-two-col">
            <!-- Registered Address -->
            <div class="address-block">
              <h5 class="address-heading">Registered Address</h5>
              <ng-container *ngIf="firm_details?.address?.house_flat_no || firm_details?.address?.street || firm_details?.address?.city_town || firm_details?.address?.state || firm_details?.address?.country || firm_details?.address?.zipcode; else noRegAddress">
                <div class="address-display">
                  <ng-container *ngIf="firm_details.address.house_flat_no">
                    <span>{{ firm_details.address.house_flat_no }},</span><br />
                  </ng-container>
                  <ng-container *ngIf="firm_details.address.city_town || firm_details.address.state">
                    <span *ngIf="firm_details.address.city_town">{{ firm_details.address.city_town }}</span><span *ngIf="firm_details.address.city_town && firm_details.address.state">, </span><span *ngIf="firm_details.address.state">{{ firm_details.address.state }},</span><br />
                  </ng-container>
                  <ng-container *ngIf="firm_details.address.country || firm_details.address.zipcode">
                    <span *ngIf="firm_details.address.country">{{ firm_details.address.country }}</span><span *ngIf="firm_details.address.country && firm_details.address.zipcode">, </span><span *ngIf="firm_details.address.zipcode">{{ firm_details.address.zipcode }}</span>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #noRegAddress>
                <div class="no-content-text">No registered address available</div>
              </ng-template>
            </div>
            <!-- Mailing Address -->
            <div class="address-block">
              <h5 class="address-heading">Mailing Address</h5>
              <ng-container *ngIf="firm_details?.correspondence_address?.house_flat_no || firm_details?.correspondence_address?.street || firm_details?.correspondence_address?.city_town || firm_details?.correspondence_address?.state || firm_details?.correspondence_address?.country || firm_details?.correspondence_address?.zipcode; else noMailAddress">
                <div class="address-display">
                  <ng-container *ngIf="firm_details.correspondence_address.house_flat_no">
                    <span>{{ firm_details.correspondence_address.house_flat_no }},</span><br />
                  </ng-container>
                  <ng-container *ngIf="firm_details.correspondence_address.city_town || firm_details.correspondence_address.state">
                    <span *ngIf="firm_details.correspondence_address.city_town">{{ firm_details.correspondence_address.city_town }}</span><span *ngIf="firm_details.correspondence_address.city_town && firm_details.correspondence_address.state">, </span><span *ngIf="firm_details.correspondence_address.state">{{ firm_details.correspondence_address.state }},</span><br />
                  </ng-container>
                  <ng-container *ngIf="firm_details.correspondence_address.country || firm_details.correspondence_address.zipcode">
                    <span *ngIf="firm_details.correspondence_address.country">{{ firm_details.correspondence_address.country }}</span><span *ngIf="firm_details.correspondence_address.country && firm_details.correspondence_address.zipcode">, </span><span *ngIf="firm_details.correspondence_address.zipcode">{{ firm_details.correspondence_address.zipcode }}</span>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #noMailAddress>
                <div class="no-content-text">No mailing address available</div>
              </ng-template>
            </div>
          </div>
        </div>

      </div>
      <!-- end VIEW MODE -->

      <!-- EDIT MODE -->
      <form *ngIf="isEditAdditionalInfo" [formGroup]="practiceDetailsForm">

        <!-- ── PROFESSIONAL INFORMATION SECTION ── -->
        <div class="practice-section-block">
          <div class="practice-section-header">
            <h4 class="practice-section-title">Professional Information</h4>
          </div>

          <div class="prof-info-two-col">

            <!-- LEFT column: Bar Council ID + Years of Exp, Billing Currency + Consultation Fee, Languages Spoken -->
            <div class="prof-info-col">

              <!-- Row 1: Bar Council ID | Years of Experience (stacked for Firm/AAM, side-by-side for My Profile) -->
              <div [ngClass]="(isFirmProfileView || isAAM) ? 'prof-info-col-stacked' : 'prof-info-row'">
                <div class="form-group">
                  <label class="field-label-edit">{{ (isFirmProfileView || isAAM) ? 'Registration ID' : 'Bar Council ID' }}</label>
                  <input type="text" formControlName="bar_council_id" class="form-control-custom" id="field-bar_council_id">
                </div>
                <div class="form-group">
                  <label class="field-label-edit">{{ (isFirmProfileView || isAAM) ? 'Year of Incorporation' : 'Years of Experience' }}</label>
                  <input type="text" inputmode="numeric" formControlName="years_of_experience" class="form-control-custom" id="field-years_of_incorporation" maxlength="3" (keydown)="blockExperienceKeys($event)" (input)="limitExperience($event)" (paste)="limitExperience($event)">
                </div>
              </div>

              <!-- Row 2: Billing Currency | Consultation Fee (My Profile only) -->
              <div class="prof-info-row" *ngIf="!isFirmProfileView && !isAAM" [formGroup]="personalInfoForm">
                <div class="form-group">
                  <label class="field-label-edit">Billing Currency <span class="required-star">*</span></label>
                  <select formControlName="billing_currency" class="form-control-custom discountry">
                    <option value="" disabled>Select currency</option>
                    <option *ngFor="let c of currencyList" [value]="c.name">{{ c.name }}</option>
                  </select>
                  <div *ngIf="shouldShowError(personalInfoForm,'billing_currency')" class="error-text">
                    <div *ngIf="personalInfoForm.get('billing_currency')?.hasError('required')">This field is required</div>
                  </div>
                </div>
                <div class="form-group" id="field-consultation_fee">
                  <label class="field-label-edit">Consultation Fee <span class="required-star">*</span></label>
                  <select formControlName="consultation_fee" class="form-control-custom">
                    <option value="" disabled>Select fee</option>
                    <option *ngFor="let fee of consultationFeeOptions" [value]="fee">{{ fee }}</option>
                  </select>
                  <div *ngIf="shouldShowError(personalInfoForm,'consultation_fee')" class="error-text">
                    <div *ngIf="personalInfoForm.get('consultation_fee')?.hasError('required')">This field is required</div>
                  </div>
                </div>
              </div>

              <!-- Row 3: Languages Spoken — My Profile only -->
              <div class="form-group" id="field-languages_spoken" *ngIf="!isFirmProfileView && !isAAM">
                <label class="field-label-edit">Languages Spoken</label>
                <div class="chip-input-field">
                  <span class="chip chip-removable chip-language"
                        *ngFor="let lang of practiceDetailsForm.get('languages_spoken')?.value">
                    {{ lang }}
                    <i class="fa fa-times" (click)="removeLanguage(lang)"></i>
                  </span>
                  <input type="text" class="chip-inline-input" placeholder="Type and press Enter"
                         [(ngModel)]="languageInput" [ngModelOptions]="{ standalone: true }"
                         (keydown.enter)="addLanguageFromInput($event)" (input)="onLanguageInputChange()" (blur)="onLanguageBlur()" />
                </div>
                <div class="chip-dropdown" *ngIf="showLanguageDropdown && filteredLanguages.length">
                  <div class="chip-dropdown-item" *ngFor="let lang of filteredLanguages"
                       (mousedown)="addLanguageFromDropdown(lang)">{{ lang }}</div>
                </div>
              </div>

            </div>

            <!-- RIGHT column: Practice Areas, Services Offered -->
            <div class="prof-info-col">

              <!-- Practice Areas -->
              <div class="form-group practice-area-wrapper">
                <label class="field-label-edit">Practice Areas <span class="required-star">*</span></label>
                <div class="chip-field-container" id="field-practice_areas"
                     [class.chip-field-invalid]="shouldShowError(practiceDetailsForm, 'practice_areas')">
                  <div class="chip-input-field" (click)="togglePracticeAreaDropdown()">
                    <span class="chip-practice chip-removable"
                          *ngFor="let area of practiceDetailsForm.get('practice_areas')?.value">
                      {{ area }}
                      <i class="fa fa-times" (click)="removePracticeArea(area); $event.stopPropagation()"></i>
                    </span>
                    <span class="chip-inline-input placeholder"
                          *ngIf="!(practiceDetailsForm.get('practice_areas')?.value?.length)">
                      Search & Select Practice Areas
                    </span>
                    <i class="fa fa-chevron-down dropdown-icon"></i>
                  </div>
                  <div class="chip-dropdown" *ngIf="showPracticeAreaDropdown">
                    <div class="dropdown-search">
                      <i class="fa fa-search"></i>
                      <input type="text" placeholder="Search..."
                             [(ngModel)]="practiceAreaSearch"
                             [ngModelOptions]="{ standalone: true }"
                             (input)="filterPracticeAreas()"
                             (click)="$event.stopPropagation()" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"/>
                    </div>
                    <div class="chip-dropdown-item"
                         *ngFor="let area of filteredPracticeAreas"
                         (click)="selectPracticeArea(area)">
                      <input type="checkbox"
                             [checked]="practiceDetailsForm.get('practice_areas')?.value?.includes(area)"
                             readonly />
                      <!-- <span>{{ area }}</span> -->
                       <div class="dropdown-item-content">
                        <span>{{area}}</span>
                        <span class="firm-tag" *ngIf="!isFirmProfileView && firm_details?.practice_areas?.includes(area)">Firm</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="shouldShowError(practiceDetailsForm, 'practice_areas')" class="error-text">
                  Practice Area is required.
                </div>
              </div>

              <!-- Services Offered -->
              <div class="form-group service-offered-wrapper" id="field-services_offered">
                <label class="field-label-edit">Services Offered</label>
                <div class="chip-field-container">
                  <div class="chip-input-field" (click)="openServiceDropdown()">
                    <span class="chip chip-removable chip-service"
                          *ngFor="let service of practiceDetailsForm.get('services_offered')?.value">
                      {{ service }}
                      <i class="fa fa-times" (click)="removeService(service); $event.stopPropagation()"></i>
                    </span>
                    <span class="chip-inline-input placeholder"
                          *ngIf="!(practiceDetailsForm.get('services_offered')?.value?.length)">
                      Search &amp; select services
                    </span>
                    <i class="fa fa-chevron-down dropdown-icon"></i>
                  </div>
                  <div class="chip-dropdown service-dropdown" *ngIf="showServiceDropdown">
                    <div class="dropdown-search">
                      <i class="fa fa-search"></i>
                      <input type="text"
                             placeholder="Search services"
                             [(ngModel)]="serviceInput"
                             [ngModelOptions]="{ standalone: true }"
                             (input)="onServiceInputChange()"
                             (click)="$event.stopPropagation()" (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"/>

                    </div>
                    <div class="service-dropdown-loading" *ngIf="isLoadingServices">
                      <i class="fa fa-spinner fa-spin"></i> Loading…
                    </div>
                    <ng-container *ngIf="!isLoadingServices">
                      <!-- Suggested Services section: hidden when expanded (showAllServices) or in search mode -->
                      <ng-container *ngIf="!showAllServices && !serviceSearchMode">
                        <div class="service-dropdown-section-label" *ngIf="filteredServices.length && hasSuggestedServices">
                          <svg class="sparkle-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <path d="M11 2.5a1 1 0 0 1 1.94 0l.74 2.96a4.5 4.5 0 0 0 3.36 3.36l2.96.74a1 1 0 0 1 0 1.94l-2.96.74a4.5 4.5 0 0 0-3.36 3.36l-.74 2.96a1 1 0 0 1-1.94 0l-.74-2.96a4.5 4.5 0 0 0-3.36-3.36l-2.96-.74a1 1 0 0 1 0-1.94l2.96-.74A4.5 4.5 0 0 0 10.26 5.46Z"/>
                            <path d="M5 16.5a.75.75 0 0 1 1.45 0l.27 1.03a2 2 0 0 0 1.42 1.42l1.03.27a.75.75 0 0 1 0 1.45l-1.03.27a2 2 0 0 0-1.42 1.42l-.27 1.03a.75.75 0 0 1-1.45 0l-.27-1.03a2 2 0 0 0-1.42-1.42l-1.03-.27a.75.75 0 0 1 0-1.45l1.03-.27a2 2 0 0 0 1.42-1.42Z"/>
                          </svg>
                          Recommended for your selected practice areas
                        </div>
                        <div class="chip-dropdown-item"
                             *ngFor="let service of filteredServices"
                             (mousedown)="toggleServiceFromDropdown(service)">
                          <input type="checkbox"
                                 [checked]="practiceDetailsForm.get('services_offered')?.value?.includes(service)"
                                 readonly />
                          <span>{{ service }}</span>
                        </div>
                      </ng-container>
                      <!-- Suggested Services in search mode (no header) -->
                      <ng-container *ngIf="serviceSearchMode">
                        <div class="chip-dropdown-item"
                             *ngFor="let service of filteredServices"
                             (mousedown)="toggleServiceFromDropdown(service)">
                          <input type="checkbox"
                                 [checked]="practiceDetailsForm.get('services_offered')?.value?.includes(service)"
                                 readonly />
                          <span>{{ service }}</span>
                        </div>
                      </ng-container>
                      <div class="chip-dropdown-empty"
                           *ngIf="!filteredServices.length && serviceInput.trim()">
                        No results found
                      </div>
                      <div class="chip-dropdown-empty"
                           *ngIf="!filteredServices.length && !serviceInput.trim()">
                        Type to search for services…
                      </div>

                      <!-- View All Services toggle (only shown when not in search mode, there are extra services,
                           and there are actual recommended services — if no recommendations exist, the dropdown
                           already shows the full list via the fallback, so the toggle would be redundant) -->
                      <ng-container *ngIf="!serviceSearchMode && viewMoreServicesList.length && hasSuggestedServices">
                        <div class="chip-dropdown-item chip-dropdown-view-more"
                             (mousedown)="$event.preventDefault(); toggleViewMoreServices()">
                          <i class="fa" [ngClass]="showAllServices ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                          <span>{{ showAllServices ? 'View All Services' : 'View All Services' }}</span>
                        </div>

                        <!-- All Services section (expanded): replaces suggested services entirely -->
                        <ng-container *ngIf="showAllServices">
                          <div class="chip-dropdown-item"
                               *ngFor="let service of viewMoreServicesList"
                               (mousedown)="toggleServiceFromDropdown(service)">
                            <input type="checkbox"
                                   [checked]="practiceDetailsForm.get('services_offered')?.value?.includes(service)"
                                   readonly />
                            <span>{{ service }}</span>
                          </div>
                        </ng-container>
                      </ng-container>

                      <div class="chip-dropdown-item chip-dropdown-other"
                           (mousedown)="selectOtherService()">
                        <i class="fa fa-plus-circle"></i> Other (enter custom)
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="other-service-entry" *ngIf="showOtherServiceInput">
                  <input type="text"
                         class="form-control-custom other-service-input"
                         placeholder="Enter custom service…"
                         [(ngModel)]="otherServiceValue"
                         [ngModelOptions]="{ standalone: true }"
                         maxlength="200"
                         (input)="onOtherServiceInput()"
                         (keydown.enter)="addOtherService()" />
                  <button type="button" class="other-service-add-btn" (click)="addOtherService()">
                    <i class="fa fa-check"></i> Add
                  </button>
                  <button type="button" class="other-service-cancel-btn" (click)="cancelOtherService()">
                    <i class="fa fa-times"></i>
                  </button>

                  <!-- Typing suggestion panel: show matching predefined services while user types -->
                  <div class="other-service-suggestions"
                       *ngIf="otherServiceSuggestions.length && !duplicateServiceMatch">
                    <div class="other-service-suggestions-label">Existing service found</div>
                    <div class="other-service-suggestion-item"
                         *ngFor="let suggestion of otherServiceSuggestions"
                         (mousedown)="$event.preventDefault(); selectExistingService(suggestion)">
                      <i class="fa fa-check" style="color:#0078D4;"></i>
                      <div>
                        <span class="suggestion-name">{{ suggestion }}</span>
                        <span class="suggestion-hint">Tap to select instead</span>
                      </div>
                    </div>
                  </div>

                  <!-- Exact duplicate warning: shown after clicking Add when exact match exists -->
                  <div class="other-service-duplicate-warning" *ngIf="duplicateServiceMatch">
                    <i class="fa fa-exclamation-triangle" style="color:#f59e0b;"></i>
                    <div>
                      <strong>This service already exists</strong>
                      <div>
                        <i class="fa fa-check" style="color:#0078D4; font-size:11px;"></i>
                        <span class="duplicate-name">{{ duplicateServiceMatch }}</span>
                      </div>
                    </div>
                    <button type="button" class="duplicate-select-btn"
                            (mousedown)="$event.preventDefault(); selectExistingService(duplicateServiceMatch)">
                      Select Existing
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- ── ADDRESSES SECTION ── -->
        <div class="practice-section-block">
          <div class="practice-section-header" style="margin-top: 10px;">
            <h4 class="practice-section-title">Addresses</h4>
          </div>
          <div class="addresses-two-col">
            <!-- Registered Address -->
            <div formGroupName="address">
              <h5 class="address-heading">Registered Address</h5>
              <!-- Hidden fields kept for API compatibility -->
              <input type="hidden" formControlName="street">
              <input type="hidden" formControlName="country">
              <!-- Row 1: Details | City -->
              <div class="address-row">
                <div class="form-group">
                  <label class="field-label-edit">Details <span class="required-star">*</span></label>
                  <input type="text" formControlName="house_flat_no"
                         [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                         [readonly]="isTMorGH">
                  <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('address'), 'house_flat_no')" class="error-text">
                    <div>This field is required</div>
                  </div>
                </div>
                <!-- <div class="form-group">
                  <label class="field-label-edit">City <span class="required-star">*</span></label>
                  <input type="text" formControlName="city_town" maxlength="50"
                         [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                         [readonly]="isTMorGH">
                  <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('address'), 'city_town')" class="error-text">
                    <div>This field is required</div>
                  </div>
                </div> -->
                <div class="form-group autocomplete-wrapper" (click)="$event.stopPropagation()">
                  <label class="field-label-edit">
                    City <span class="required-star">*</span>
                  </label>
                
                  <input type="text" formControlName="city_town" maxlength="50" autocomplete="off" class="form-control-custom"
                    [readonly]="isTMorGH" (focus)="filterCities(
                      practiceDetailsForm.get('address.city_town')?.value,
                      'registered'
                    )" (input)="filterCities(
                      practiceDetailsForm.get('address.city_town')?.value,
                      'registered'
                    )" />
                
                  <div class="autocomplete-dropdown" *ngIf="showRegisteredCityDropdown && !isTMorGH">
                    <div class="autocomplete-option" *ngFor="let city of filteredRegisteredCities"
                      (mousedown)="selectCity(city, 'registered')">
                      {{ city }}
                    </div>
                
                    <div class="autocomplete-no-result" *ngIf="filteredRegisteredCities.length === 0">
                      No cities found
                    </div>
                  </div>
                
                  <div *ngIf="!isTMorGH &&
                      shouldShowError(
                        practiceDetailsForm.get('address'),
                        'city_town'
                      )" class="error-text">
                    <div>This field is required</div>
                  </div>
                </div>
              </div>
              <!-- Row 2: State | Pincode -->
              <div class="address-row">
                <!-- <div class="form-group">
                  <label class="field-label-edit">State <span class="required-star">*</span></label>
                  <input type="text" formControlName="state" maxlength="50"
                         [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                         [readonly]="isTMorGH">
                  <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('address'), 'state')" class="error-text">
                    <div>This field is required</div>
                  </div>
                </div> -->
                <div class="form-group autocomplete-wrapper" (click)="$event.stopPropagation()">
                  <label class="field-label-edit">
                    State <span class="required-star">*</span>
                  </label>
                
                  <input type="text" formControlName="state" maxlength="50" autocomplete="off" class="form-control-custom"
                    [readonly]="isTMorGH" (focus)="filterStates(
                      practiceDetailsForm.get('address.state')?.value,
                      'registered'
                    )" (input)="filterStates(
                      practiceDetailsForm.get('address.state')?.value,
                      'registered'
                    )" />
                
                  <div class="autocomplete-dropdown" *ngIf="showRegisteredStateDropdown && !isTMorGH">
                    <div class="autocomplete-option" *ngFor="let state of filteredRegisteredStates"
                      (mousedown)="selectState(state, 'registered')">
                      {{ state }}
                    </div>
                
                    <div class="autocomplete-no-result" *ngIf="filteredRegisteredStates.length === 0">
                      No states found
                    </div>
                  </div>
                
                  <div *ngIf="!isTMorGH &&
                      shouldShowError(
                        practiceDetailsForm.get('address'),
                        'state'
                      )" class="error-text">
                    <div>This field is required</div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="field-label-edit">Pincode <span class="required-star">*</span></label>
                  <input type="text" formControlName="zipcode" maxlength="6"
                         (keypress)="!isTMorGH && allowOnlyNumbers($event)"
                         [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                         [readonly]="isTMorGH">
                  <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('address'), 'zipcode')" class="error-text">
                    <div *ngIf="practiceDetailsForm.get('address')?.get('zipcode')?.hasError('required')">This field is required</div>
                    <div *ngIf="practiceDetailsForm.get('address')?.get('zipcode')?.hasError('pattern')">Invalid zip code</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mailing Address -->
            <div>
              <div class="address-header-flex">
                <h5 class="address-heading">Mailing Address</h5>
                <label *ngIf="!isTMorGH" class="checkbox-container-edit">
                  <!-- <input type="checkbox" formControlName="sameAsRegistered"> -->
                  <input type="checkbox" formControlName="sameAsRegistered" (change)="onSameAsRegisteredChange($event)">
                  <span class="checkbox-text">Same as Registered Address</span>
                </label>
              </div>
              <div formGroupName="correspondence_address">
                <!-- Hidden fields kept for API compatibility -->
                <input type="hidden" formControlName="street">
                <input type="hidden" formControlName="country">
                <!-- Row 1: Details | City -->
                <div class="address-row">
                  <div class="form-group">
                    <label class="field-label-edit">Details <span class="required-star">*</span></label>
                    <input type="text" formControlName="house_flat_no"
                           [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                           [readonly]="isTMorGH">
                    <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('correspondence_address'), 'house_flat_no')" class="error-text">
                      <div>This field is required</div>
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <label class="field-label-edit">City <span class="required-star">*</span></label>
                    <input type="text" formControlName="city_town" maxlength="50"
                           [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                           [readonly]="isTMorGH">
                    <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('correspondence_address'), 'city_town')" class="error-text">
                      <div>This field is required</div>
                    </div>
                  </div> -->
                  <div class="form-group autocomplete-wrapper" (click)="$event.stopPropagation()">
                    <label class="field-label-edit">
                      City <span class="required-star">*</span>
                    </label>
                  
                    <input type="text" formControlName="city_town" maxlength="50" autocomplete="off" class="form-control-custom"
                      [readonly]="isTMorGH" (focus)="filterCities(
                        practiceDetailsForm.get('correspondence_address.city_town')?.value,
                        'mailing'
                      )" (input)="filterCities(
                        practiceDetailsForm.get('correspondence_address.city_town')?.value,
                        'mailing'
                      )" />
                  
                    <div class="autocomplete-dropdown" *ngIf="showMailingCityDropdown && !isTMorGH">
                      <div class="autocomplete-option" *ngFor="let city of filteredMailingCities"
                        (mousedown)="selectCity(city, 'mailing')">
                        {{ city }}
                      </div>
                  
                      <div class="autocomplete-no-result" *ngIf="filteredMailingCities.length === 0">
                        No cities found
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Row 2: State | Pincode -->
                <div class="address-row">
                  <!-- <div class="form-group">
                    <label class="field-label-edit">State <span class="required-star">*</span></label>
                    <input type="text" formControlName="state" maxlength="50"
                           [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                           [readonly]="isTMorGH">
                    <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('correspondence_address'), 'state')" class="error-text">
                      <div>This field is required</div>
                    </div>
                  </div> -->
                  <div class="form-group autocomplete-wrapper" (click)="$event.stopPropagation()">
                    <label class="field-label-edit">
                      State <span class="required-star">*</span>
                    </label>
                  
                    <input type="text" formControlName="state" maxlength="50" autocomplete="off" class="form-control-custom"
                      [readonly]="isTMorGH" (focus)="filterStates(
                        practiceDetailsForm.get('correspondence_address.state')?.value,
                        'mailing'
                      )" (input)="filterStates(
                        practiceDetailsForm.get('correspondence_address.state')?.value,
                        'mailing'
                      )" />
                  
                    <div class="autocomplete-dropdown" *ngIf="showMailingStateDropdown && !isTMorGH">
                      <div class="autocomplete-option" *ngFor="let state of filteredMailingStates"
                        (mousedown)="selectState(state, 'mailing')">
                        {{ state }}
                      </div>
                  
                      <div class="autocomplete-no-result" *ngIf="filteredMailingStates.length === 0">
                        No states found
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="field-label-edit">Pincode <span class="required-star">*</span></label>
                    <input type="text" formControlName="zipcode" maxlength="6"
                           (keypress)="!isTMorGH && allowOnlyNumbers($event)"
                           [ngClass]="{'form-control-custom': true, 'discountry': isTMorGH}"
                           [readonly]="isTMorGH">
                    <div *ngIf="!isTMorGH && shouldShowError(practiceDetailsForm.get('correspondence_address'), 'zipcode')" class="error-text">
                      <div *ngIf="practiceDetailsForm.get('correspondence_address')?.get('zipcode')?.hasError('required')">This field is required</div>
                      <div *ngIf="practiceDetailsForm.get('correspondence_address')?.get('zipcode')?.hasError('pattern')">Invalid zip code</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── COURT PRACTICE DETAILS moved to Courts & Cases tab ── -->

        <!-- Save/Cancel at bottom of inner card (all roles) -->
        <div class="inner-card-save-bar">
          <button type="reset" class="btn btn-default btncancel" (click)="cancelAdditionalInfo()">Cancel</button>
          <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveAdditionalInfo()">Save</button>
        </div>
      </form>
    </div>

    <!-- ========================================
         COURTS & CASES TAB
         ======================================== -->
    <div class="tab-content-area" *ngIf="activeTab === 'courts_cases'">

      <!-- Inner card top-right action bar -->
      <div *ngIf="!isEditAdditionalInfo" class="inner-card-action-bar">
        <button class="edit-section-btn" (click)="editAdditionalInfo()">
          <i class="fa fa-edit"></i> Edit
        </button>
      </div>

      <!-- VIEW MODE -->
      <div *ngIf="!isEditAdditionalInfo" class="courts-cases-two-col">

        <!-- LEFT: Practicing At -->
        <div class="courts-cases-col">
          <h4 class="section-sub-heading">Practicing At</h4>
          <ng-container *ngIf="basic_profile?.court_enrollments?.length > 0; else noCourtEnrollmentsCC">
            <div class="court-enrollment-view-grid">
              <div class="court-enrollment-view-item" *ngFor="let court of basic_profile.court_enrollments">
                <span class="court-view-badge court-type-badge">{{ getCourtTypeLabel(court.court_type) }}</span>
                <span class="court-view-separator" *ngIf="court.state">·</span>
                <span class="court-view-text" *ngIf="court.state">{{ court.state }}</span>
                <span class="court-view-separator" *ngIf="court.city">·</span>
                <span class="court-view-text" *ngIf="court.city">{{ court.city }}</span>
              </div>
            </div>
          </ng-container>
          <ng-template #noCourtEnrollmentsCC>
            <div class="no-content-text">No courts added</div>
          </ng-template>
        </div>

        <!-- RIGHT: Types of Cases Handled -->
        <div class="courts-cases-col">
          <h4 class="section-sub-heading">Types of Cases Handled</h4>
          <div class="tags-container" *ngIf="basic_profile?.cases_handled?.length">
            <span class="tag" *ngFor="let c of basic_profile.cases_handled">{{ c }}</span>
          </div>
          <div class="no-content-text" *ngIf="!basic_profile?.cases_handled?.length">No case types specified</div>
        </div>

      </div>

      <!-- EDIT MODE -->
      <form *ngIf="isEditAdditionalInfo" [formGroup]="practiceDetailsForm">
        <div class="courts-cases-two-col">

          <!-- LEFT: Court Practice Details -->
          <div class="courts-cases-col">
            <div class="practice-section-block court-practice-edit-section">
              <div class="practice-section-header">
                <h4 class="section-sub-heading">Practicing At</h4>
                <button type="button" class="add-link-btn"
                        (click)="addCourtEnrollment()">
                  <i class="fa fa-plus"></i> Add Court
                </button>
              </div>
              <!-- Court rows -->
              <div class="court-edit-full-width" (click)="$event.stopPropagation()">
                <!-- Labels header row (shown only when rows exist) -->
                <div class="court-edit-labels-row" *ngIf="courtEnrollments.controls.length > 0">
                  <span>Court Type <span class="required-star">*</span></span>
                  <span>State <span class="required-star">*</span></span>
                  <span>City <span class="required-star">*</span></span>
                  <span></span>
                </div>

                <div class="court-edit-rows-grid" formArrayName="court_enrollments" id="field-court_enrollments">
                  <div class="court-edit-row" *ngFor="let row of courtEnrollments.controls; let i = index" [formGroupName]="i">

                    <!-- ── Court Type ── -->
                    <div class="court-row-field">
                      <div class="court-custom-select" [class.open]="activeCourtTypeDropdown === i">
                        <div class="court-select-trigger" (click)="toggleCourtTypeDropdown(i)">
                          <span [ngClass]="{'placeholder-text': !row.get('court_type')?.value}">
                            {{ row.get('court_type')?.value || 'Select Court Type' }}
                          </span>
                          <i class="fa fa-chevron-down court-select-arrow"></i>
                        </div>
                        <div class="court-select-dropdown" *ngIf="activeCourtTypeDropdown === i">
                          <div class="court-select-search">
                            <i class="fa fa-search"></i>
                            <input type="text" placeholder="Search court type..."
                                   [(ngModel)]="courtTypeSearch[i]"
                                   [ngModelOptions]="{standalone: true}"
                                   (click)="$event.stopPropagation()" />
                          </div>
                          <div class="court-select-loading" *ngIf="isLoadingCourtTypes">
                            <i class="fa fa-spinner fa-spin"></i> Loading…
                          </div>
                          <div class="court-select-options-list" *ngIf="!isLoadingCourtTypes" [id]="'court-options-list-' + i">

                            <!-- Suggested Courts section: only when not expanded and not searching and real suggestions exist -->
                            <ng-container *ngIf="showAllCourtTypes === null || showAllCourtTypes !== i">
                              <ng-container *ngIf="!courtTypeSearch[i]">
                                <div class="court-select-section-label" *ngIf="hasSuggestedCourtTypes && courtSuggestedTypes.length">Suggested Courts</div>
                                <div class="court-select-option"
                                     *ngFor="let opt of getFilteredCourtTypes(i)"
                                     [class.selected]="row.get('court_type')?.value === opt"
                                     (mousedown)="selectCourtType(i, opt)">
                                  {{ opt }}
                                  <i class="fa fa-check court-check-icon" *ngIf="row.get('court_type')?.value === opt"></i>
                                </div>
                              </ng-container>
                              <!-- Search mode: show filtered results from full list, no header -->
                              <ng-container *ngIf="courtTypeSearch[i]">
                                <div class="court-select-option"
                                     *ngFor="let opt of getFilteredCourtTypes(i)"
                                     [class.selected]="row.get('court_type')?.value === opt"
                                     (mousedown)="selectCourtType(i, opt)">
                                  {{ opt }}
                                  <i class="fa fa-check court-check-icon" *ngIf="row.get('court_type')?.value === opt"></i>
                                </div>
                              </ng-container>
                            </ng-container>

                            <!-- Expanded: show full list, no suggested section -->
                            <ng-container *ngIf="showAllCourtTypes === i && !courtTypeSearch[i]">
                              <div class="court-select-option"
                                   *ngFor="let opt of getFilteredCourtTypes(i)"
                                   [class.selected]="row.get('court_type')?.value === opt"
                                   (mousedown)="selectCourtType(i, opt)">
                                {{ opt }}
                                <i class="fa fa-check court-check-icon" *ngIf="row.get('court_type')?.value === opt"></i>
                              </div>
                            </ng-container>

                            <div class="court-select-empty" *ngIf="getFilteredCourtTypes(i).length === 0">No results</div>

                            <!-- View All / Collapse toggle: only when not in search mode and full list exists -->
                            <ng-container *ngIf="!courtTypeSearch[i] && courtAllPredefinedTypes.length">
                              <div class="court-select-view-more" (mousedown)="$event.preventDefault(); toggleViewMoreCourtTypes(i)">
                                <i class="fa" [ngClass]="showAllCourtTypes === i ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                <span>View All Courts</span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="isCourtFieldInvalid(i, 'court_type')" class="error-text">Required</div>
                    </div>

                    <!-- ── State ── -->
                    <div class="court-row-field">
                      <div class="court-custom-select" [class.open]="activeCourtStateDropdown === i"
                           [class.discountry]="row.get('court_type')?.value?.toLowerCase() === 'supreme court' ||
                            row.get('court_type')?.value?.toLowerCase() === 'supreme court of india'">
                        <div class="court-select-trigger" (click)="toggleCourtStateDropdown(i)">
                          <span [ngClass]="{'placeholder-text': !row.get('state')?.value}">
                            {{ row.get('state')?.value || 'Select State' }}
                          </span>
                          <i class="fa fa-chevron-down court-select-arrow"></i>
                        </div>
                        <div class="court-select-dropdown" *ngIf="activeCourtStateDropdown === i">
                          <div class="court-select-search">
                            <i class="fa fa-search"></i>
                            <input type="text" placeholder="Search state..."
                                   [(ngModel)]="courtStateSearch[i]"
                                   [ngModelOptions]="{standalone: true}"
                                   (click)="$event.stopPropagation()" />
                          </div>
                          <div class="court-select-options-list">
                            <div class="court-select-option"
                                 *ngFor="let s of getFilteredCourtStates(i)"
                                 [class.selected]="row.get('state')?.value === s"
                                 (mousedown)="selectCourtState(i, s)">
                              {{ s }}
                              <i class="fa fa-check court-check-icon" *ngIf="row.get('state')?.value === s"></i>
                            </div>
                            <div class="court-select-empty" *ngIf="getFilteredCourtStates(i).length === 0">No results</div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="isCourtFieldInvalid(i, 'state')" class="error-text">Required</div>
                    </div>

                    <!-- ── City ── -->
                    <div class="court-row-field">
                      <ng-container *ngIf="!showCityOtherInput[i]">
                        <div class="court-custom-select" [class.open]="activeCourtCityDropdown === i"
                             [class.discountry]="row.get('court_type')?.value?.toLowerCase() === 'supreme court' || 
                             row.get('court_type')?.value?.toLowerCase() === 'supreme court of india'">
                          <div class="court-select-trigger" 
                          (click)="row.get('court_type')?.value?.toLowerCase() !== 'supreme court' &&
                                   row.get('court_type')?.value?.toLowerCase() !== 'supreme court of india' ? toggleCourtCityDropdown(i) : null">
                            <span [ngClass]="{'placeholder-text': !row.get('city')?.value}">
                              {{ row.get('city')?.value || 'Select City' }}
                            </span>
                            <i class="fa fa-chevron-down court-select-arrow"></i>
                          </div>
                          <div class="court-select-dropdown" *ngIf="activeCourtCityDropdown === i">
                            <div class="court-select-search">
                              <i class="fa fa-search"></i>
                              <input type="text" placeholder="Search city..."
                                     [(ngModel)]="courtCitySearch[i]"
                                     [ngModelOptions]="{standalone: true}"
                                     (click)="$event.stopPropagation()" />
                            </div>
                            <div class="court-select-options-list">
                              <div class="court-select-option"
                                   *ngFor="let c of getFilteredCourtCities(i)"
                                   [class.selected]="row.get('city')?.value === c"
                                   (mousedown)="selectCourtCity(i, c)">
                                {{ c }}
                                <i class="fa fa-check court-check-icon" *ngIf="row.get('city')?.value === c"></i>
                              </div>
                              <div class="court-select-option court-other-option"
                                   (mousedown)="selectCourtCity(i, '__other__')">
                                <i class="fa fa-plus-circle" style="color: #007bff;"></i> Other (enter custom)
                              </div>
                              <div class="court-select-empty"
                                   *ngIf="getFilteredCourtCities(i).length === 0 && courtCitySearch[i]">
                                No results
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="showCityOtherInput[i]">
                        <div class="court-city-other-wrap">
                          <input type="text" class="court-city-other-input"
                                 placeholder="Enter city name"
                                 [(ngModel)]="courtCityOtherInput[i]"
                                 [ngModelOptions]="{standalone: true}"
                                 maxlength="100"
                                 (keydown.enter)="confirmOtherCity(i)" />
                          <div class="court-city-other-actions">
                            <button type="button" class="court-other-confirm-btn" (click)="confirmOtherCity(i)" title="Confirm">
                              <i class="fa fa-check"></i>
                            </button>
                            <button type="button" class="court-other-cancel-btn"
                                    (click)="showCityOtherInput[i] = false; courtCityOtherInput[i] = ''"
                                    title="Cancel">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                        </div>
                      </ng-container>
                      <div *ngIf="isCourtFieldInvalid(i, 'city')" class="error-text">Required</div>
                    </div>

                    <!-- Delete -->
                    <div class="court-row-delete">
                      <button type="button" class="remove-court-btn" (click)="removeCourtEnrollment(i)" title="Remove">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="no-content-text court-empty-text" *ngIf="courtEnrollments.controls.length === 0">
                  No courts added. Click "+ Add Court" to add.
                </div>
              </div>
            </div>
          </div>

          <!-- RIGHT: Types of Cases Handled -->
          <div class="courts-cases-col">
            <div class="practice-section-block">
              <div class="practice-section-header">
                <h4 class="section-sub-heading">Types of Cases Handled</h4>
              </div>
              <div class="form-group case-handled-wrapper" id="field-cases_handled">
                <!-- Input only — no chips inside -->
                <div class="chip-input-field case-handled-input-field">
                  <input type="text" class="chip-inline-input" placeholder="Type and press Enter"
                         #caseHandledInputRef
                         [(ngModel)]="caseHandledInput" [ngModelOptions]="{ standalone: true }"
                         maxlength="500"
                         (keydown.enter)="addCaseHandledFromInput($event)" />
                </div>
                <!-- Live character counter -->
                <div class="case-handled-char-count"
                     [class.case-handled-char-limit]="caseHandledInput.length >= 500">
                  {{ caseHandledInput.length }} / 500
                </div>
                <!-- Tags displayed below the input -->
                <div class="case-handled-tags" *ngIf="practiceDetailsForm.get('cases_handled')?.value?.length">
                  <span class="chip chip-removable chip-case"
                        *ngFor="let c of practiceDetailsForm.get('cases_handled')?.value; let i = index"
                        [style.display]="i === editingCaseIndex ? 'none' : ''">
                    {{ c }}
                    <i class="fa fa-pencil case-edit-icon" title="Edit" (click)="editCaseHandled(c, i)"></i>
                    <i class="fa fa-times" title="Remove" (click)="removeCaseHandled(c)"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Save/Cancel -->
        <div class="inner-card-save-bar">
          <button type="reset" class="btn btn-default btncancel" (click)="cancelAdditionalInfo()">Cancel</button>
          <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveAdditionalInfo()">Save</button>
        </div>
      </form>
    </div>

    <!-- ========================================
         EDUCATION & AWARDS TAB
         ======================================== -->
    <div class="tab-content-area" *ngIf="activeTab === 'education'">

      <!-- Inner card top-right action bar -->
      <div *ngIf="!isEditAdditionalInfo" class="inner-card-action-bar">
        <button class="edit-section-btn" (click)="editAdditionalInfo()">
          <i class="fa fa-edit"></i> Edit
        </button>
      </div>

      <!-- VIEW MODE -->
      <div *ngIf="!isEditAdditionalInfo" class="education-awards-container">

        <!-- SU Firm Profile / AAM: Awards only, true 2-column grid -->
        <ng-container *ngIf="isFirmProfileView || isAAM">
          <div class="awards-full-width">
            <h4 class="section-sub-heading">Awards & Recognitions</h4>
            <div class="awards-two-col-grid" *ngIf="firm_details?.awards?.length > 0">
              <div class="education-item" *ngFor="let award of firm_details?.awards">
                <div class="edu-degree">{{award.award_name}}</div>
                <div class="edu-university">{{award.purpose}}  {{award.year_of_award}}</div>
              </div>
            </div>
            <div class="no-content-text" *ngIf="!firm_details?.awards || firm_details?.awards?.length === 0">
              No awards added
            </div>
          </div>
        </ng-container>

        <!-- All other roles: existing layout with Education, Certifications, Awards -->
        <ng-container *ngIf="!isFirmProfileView && !isAAM">
          <!-- LEFT COLUMN -->
          <div class="education-left-column">
            <div class="education-section">
              <h4 class="section-sub-heading">Educational Qualifications</h4>
              <div class="education-list" *ngIf="basic_profile?.education?.length > 0">
                <div class="education-item" *ngFor="let edu of basic_profile?.education">
                  <div class="edu-degree">{{edu.degree}}</div>
                  <div class="edu-university">{{edu.university}} {{edu.passing_year}}</div>
                </div>
              </div>
              <div class="no-content-text" *ngIf="!basic_profile?.education || basic_profile?.education?.length === 0">
                No educational qualifications added
              </div>
            </div>

            <div class="education-section">
              <h4 class="section-sub-heading">Certifications</h4>
              <div class="education-list" *ngIf="basic_profile?.certifications?.length > 0">
                <div class="education-item" *ngFor="let cert of basic_profile?.certifications">
                  <div class="edu-degree">{{cert.certification_name}}</div>
                  <div class="edu-university">{{cert.issuing_authority}}  {{cert.year_of_issue}}</div>
                </div>
              </div>
              <div class="no-content-text" *ngIf="!basic_profile?.certifications || basic_profile?.certifications?.length === 0">
                No certifications added
              </div>
            </div>
          </div>

          <!-- RIGHT COLUMN -->
          <div class="education-right-column">
            <div class="education-section">
              <h4 class="section-sub-heading">Awards & Recognitions (Optional)</h4>
              <div class="education-list" *ngIf="basic_profile?.awards?.length > 0">
                <div class="education-item" *ngFor="let award of basic_profile?.awards">
                  <div class="edu-degree">{{award.award_name}}</div>
                  <div class="edu-university">{{award.purpose}}  {{award.year_of_award}}</div>
                </div>
              </div>
              <div class="no-content-text" *ngIf="!basic_profile?.awards || basic_profile?.awards?.length === 0">
                No awards added
              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <!-- EDIT MODE -->
      <form *ngIf="isEditAdditionalInfo" [formGroup]="educationForm">
        <div class="education-awards-container">

          <!-- SU Firm Profile / AAM: Awards only, full-width with Add Award top-right -->
          <ng-container *ngIf="isFirmProfileView || isAAM">
            <div class="awards-full-width">
              <div class="awards-edit-header">
                <h4 class="section-sub-heading">Awards & Recognitions</h4>
                <button type="button" class="add-link-btn" (click)="addAward()">
                  <i class="fa fa-plus"></i> Add Award
                </button>
              </div>
              <div formArrayName="awards" id="field-awards">
                <div class="awards-inline-item" *ngFor="let award of awards.controls; let i = index" [formGroupName]="i">
                  <input type="text" formControlName="award_name" placeholder="Award Name *" maxlength="120"
                         [ngClass]="{'inline-input': true, 'input-error': shouldShowError(award, 'award_name')}">
                  <input type="text" formControlName="purpose" class="inline-input" maxlength="150" placeholder="Institution">
                  <input type="number" formControlName="year_of_award" class="inline-input year-input"
                         [min]="1900" placeholder="Year">
                  <button type="button" class="remove-inline-btn" (click)="removeAward(i)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="no-content-text" *ngIf="awards.length === 0">No awards added</div>
            </div>
          </ng-container>

          <!-- All other roles: full layout -->
          <ng-container *ngIf="!isFirmProfileView && !isAAM">
            <!-- LEFT COLUMN -->
            <div class="education-left-column">
              <div class="education-section">
                <div class="section-header-with-btn">
                  <h4 class="section-sub-heading">Educational Qualifications</h4>
                  <button type="button" class="add-link-btn" (click)="addEducation()">
                    <i class="fa fa-plus"></i> Add More Qualification
                  </button>
                </div>
                <div formArrayName="education" id="field-education">
                  <div class="education-inline-item" *ngFor="let edu of education.controls; let i = index" [formGroupName]="i">
                    <input type="text" formControlName="degree" class="inline-input" maxlength="100" placeholder="Degree Name" >
                    <input type="text" formControlName="university" class="inline-input" maxlength="120" placeholder="Institution">
                    <input type="number" formControlName="passing_year" class="inline-input year-input"
                           [min]="1900" placeholder="Year">
                    <button type="button" class="remove-inline-btn" (click)="removeEducation(i)">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="no-content-text" *ngIf="education.length === 0">No educational qualifications added</div>
              </div>

              <div class="education-section">
                <div class="section-header-with-btn">
                  <h4 class="section-sub-heading">Certifications</h4>
                  <button type="button" class="add-link-btn" (click)="addCertification()">
                    <i class="fa fa-plus"></i> Add Certification
                  </button>
                </div>
                <div formArrayName="certifications" id="field-certifications">
                  <div class="education-inline-item" *ngFor="let cert of certifications.controls; let i = index" [formGroupName]="i">
                    <input type="text" formControlName="certification_name" class="inline-input" maxlength="120" placeholder="Certificate Name">
                    <input type="text" formControlName="issuing_authority" class="inline-input" maxlength="120" placeholder="Institution">
                    <input type="number" formControlName="year_of_issue" class="inline-input year-input"
                           [min]="1900" placeholder="Year">
                    <button type="button" class="remove-inline-btn" (click)="removeCertification(i)">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="no-content-text" *ngIf="certifications.length === 0">No certifications added</div>
              </div>
            </div>

            <!-- RIGHT COLUMN -->
            <div class="education-right-column">
              <div class="education-section">
                <div class="section-header-with-btn">
                  <h4 class="section-sub-heading">Awards & Recognitions (Optional)</h4>
                  <button type="button" class="add-link-btn" (click)="addAward()">
                    <i class="fa fa-plus"></i> Add Award
                  </button>
                </div>
                <div formArrayName="awards" id="field-awards">
                  <div class="education-inline-item" *ngFor="let award of awards.controls; let i = index" [formGroupName]="i">
                    <input type="text" formControlName="award_name" placeholder="Award Name *" maxlength="120"
                           [ngClass]="{'inline-input': true, 'input-error': shouldShowError(award, 'award_name')}">
                    <input type="text" formControlName="purpose" class="inline-input" maxlength="150" placeholder="Institution">
                    <input type="number" formControlName="year_of_award" class="inline-input year-input"
                           [min]="1900" placeholder="Year">
                    <button type="button" class="remove-inline-btn" (click)="removeAward(i)">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="no-content-text" *ngIf="awards.length === 0">No awards added</div>
              </div>
            </div>
          </ng-container>

        </div>
        <!-- Non-AAM, non-FirmProfileView Save/Cancel at bottom of inner card -->
        <div *ngIf="!isAAM && !isFirmProfileView" class="inner-card-save-bar">
          <button type="reset" class="btn btn-default btncancel" (click)="cancelAdditionalInfo()">Cancel</button>
          <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveAdditionalInfo()">Save</button>
        </div>
        <!-- SU Firm Profile / AAM: Save/Cancel for awards -->
        <div *ngIf="isFirmProfileView || isAAM" class="inner-card-save-bar">
          <button type="reset" class="btn btn-default btncancel" (click)="cancelAdditionalInfo()">Cancel</button>
          <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveAdditionalInfo()">Save</button>
        </div>
      </form>
    </div>

    <!-- ========================================
     AVAILABILITY TAB
     ======================================== -->
<div class="tab-content-area" *ngIf="activeTab === 'availability'">

  <!-- Inner card top-right action bar (only in view mode) -->
  <div *ngIf="!isEditAdditionalInfo" class="inner-card-action-bar">
    <div class="edit-disabled-tooltip-wrapper">
      <button class="edit-section-btn" (click)="editAdditionalInfo()" [disabled]="!isMarketplaceListed">
        <i class="fa fa-edit"></i> Edit
      </button>
      <div class="edit-disabled-tooltip" *ngIf="!isMarketplaceListed">
        <strong>Editing is paused</strong>
        <p>Turn on "Available for Consultations" to edit your weekly availability.</p>
      </div>
    </div>
  </div>

  <!-- VIEW MODE -->
  <div *ngIf="!isEditAdditionalInfo" class="availability-settings">
    <div class="weekly-schedule-section">
       <div class="weekly-header">
        <div class="weekly-title">
          <i class="fa-regular fa-clock weekly-icon"></i>
          <h4>Weekly hours</h4>
          <!-- Tooltip info icon -->
          <div class="info-tooltip-wrapper">
            <i class="fa fa-info-circle info-icon-tooltip"></i>
            <div class="tooltip-content">
              <strong>How it works:</strong><br />
              Set your available hours. We'll automatically create 30-minute booking slots.<br />
              Need a break? Click Exclude icon to block specific times (e.g., 12:00–1:00 PM).
            </div>
          </div>
        </div>
      </div>
      <p class="weekly-subtitle">Set when you are typically available for meetings</p>

      <div class="weekly-schedule-view-mode" *ngIf="basic_profile?.availability?.weekly_schedule">
        <div class="day-view-card" *ngFor="let day of basic_profile?.availability?.weekly_schedule">
          <div class="day-view-header">
            <span class="day-view-name">{{day.date_label || day.day_name}}</span>
            <div class="day-view-content" *ngIf="day.is_working_day && day.work_slots?.length > 0">
              <span class="day-view-time">
                {{convertTo12Hour(day.work_slots[0].start_time)}} – {{convertTo12Hour(day.work_slots[0].end_time)}}
              </span>
              <span class="available-badge">
                <i class="fa fa-check-circle"></i>
                {{ calculateAvailableHours(day.work_slots[0].start_time, day.work_slots[0].end_time, 
                   getSlotRanges(day.expert_slots)) }} hours available
              </span>
            </div>
            <span class="not-available-view" *ngIf="!day.is_working_day || !day.work_slots?.length">Not available</span>
          </div>
          
          <div class="blocked-slots-view" *ngIf="day.is_working_day && day.expert_slots && day.expert_slots.length > 0">
            <div class="blocked-info-row">
              <i class="fa fa-ban blocked-icon-view"></i>
              <span class="blocked-label-view">Excluded:</span>
              <span class="blocked-times-view">
                <span *ngFor="let slot of day.expert_slots; let last = last">
                  {{convertTo12Hour(slot.start_time)}}–{{convertTo12Hour(slot.end_time)}}<span *ngIf="!last">, </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="no-content-text" *ngIf="!basic_profile?.availability?.weekly_schedule || 
           basic_profile?.availability?.weekly_schedule?.length === 0">
        No availability schedule set
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->
  <form *ngIf="isEditAdditionalInfo" [formGroup]="availabilityForm" id="field-availability">
    <div class="weekly-schedule-section">
      <div class="weekly-header">
        <div class="weekly-title">
          <i class="fa-regular fa-clock weekly-icon"></i>
          <h4>Weekly hours</h4>
          <!-- Tooltip info icon -->
          <div class="info-tooltip-wrapper">
            <i class="fa fa-info-circle info-icon-tooltip"></i>
            <div class="tooltip-content">
              <strong>How it works:</strong><br />
              Set your available hours. We'll automatically create 30-minute booking slots.<br />
              Need a break? Click Exclude icon to block specific times (e.g., 12:00–1:00 PM).
            </div>
          </div>
        </div>
      </div>
      <p class="weekly-subtitle">Set when you are typically available for meetings</p>

      <div formArrayName="weekly_schedule" class="days-schedule-container">
        <div class="day-schedule-card" *ngFor="let day of weeklySchedule.controls; let dayIndex = index" [formGroupName]="dayIndex">
          
          <div class="day-header-row">
            <label class="day-checkbox-label">
              <input type="checkbox" [checked]="day.get('is_working_day')?.value" (change)="toggleWorkingDay(dayIndex)">
              <span class="day-box"></span>
              <span class="day-name-text">{{day.get('date_label')?.value || day.get('day_name')?.value}}</span>
            </label>

            <div class="day-time-controls" *ngIf="day.get('is_working_day')?.value && getWorkSlots(dayIndex).length > 0">
              <div formArrayName="work_slots" class="time-slots-inline">
                <div class="time-slot-inline" *ngFor="let slot of getWorkSlots(dayIndex).controls; let slotIndex = index" [formGroupName]="slotIndex">
                  <select class="time-select-dropdown" [ngModel]="convertTo12Hour(slot.get('start_time')?.value)"
                          [ngModelOptions]="{standalone: true}" (ngModelChange)="onStartTimeChange(dayIndex, slotIndex, $event)">
                    <option *ngFor="let time of timeOptions" [value]="time">{{ time }}</option>
                  </select>
                  <span class="time-dash">–</span>
                  <select class="time-select-dropdown" [ngModel]="convertTo12Hour(slot.get('end_time')?.value)"
                          [ngModelOptions]="{standalone: true}" (ngModelChange)="onEndTimeChange(dayIndex, slotIndex, $event)">
                    <option *ngFor="let time of getEndTimeOptions(convertTo12Hour(slot.get('start_time')?.value))" [value]="time">
                      {{ time }}
                    </option>
                  </select>
                </div>
              </div>
              
              <div class="exclude-icon-wrapper">
                <button type="button" class="exclude-icon-btn" [class.disabled]="!canExcludeSlots(dayIndex)"
                        [disabled]="!canExcludeSlots(dayIndex)" (click)="openExcludePanel(dayIndex)"
                        [title]="getExcludeTooltip(dayIndex)">
                  <i class="fa fa-ban"></i>
                </button>
              </div>
            </div>
            
            <span class="not-available-text" *ngIf="!day.get('is_working_day')?.value">Not available</span>
          </div>
          
          <div class="exclude-panel-inline" *ngIf="activeExcludeDayIndex === dayIndex">
            <div class="exclude-panel-header">
              <div class="exclude-title">
                <span class="minus">–</span>
                <span>Select slots to exclude</span>
              </div>
              <button class="exclude-close-btn" type="button" (click)="closeExcludePanel()">✕</button>
            </div>

            <div class="exclude-panel-subtitle">
              Click 30-minute slots to exclude ({{tempSelectedExcludeSlots.length}}/{{MAX_EXCLUDE_SLOTS}} slots, max 2 hours)
            </div>

            <div class="exclude-slots-grid">
              <button type="button" *ngFor="let slot of availableExcludeSlots" class="exclude-slot"
                      [class.selected]="isSlotSelected(getSlotKey(slot))" (click)="toggleExcludeSlot(getSlotKey(slot))">
                {{convertTo12Hour(slot.start)}} - {{convertTo12Hour(slot.end)}}
              </button>
            </div>

            <div class="exclude-actions">
              <button type="button" class="btn-cancel" (click)="closeExcludePanel()">Cancel</button>
              <button type="button" class="btn-save" (click)="saveExcludedSlots()">Save</button>
            </div>
          </div>

          <div class="excluded-slots-info"
               *ngIf="day.get('is_working_day')?.value && getWorkSlots(dayIndex).length > 0">

            <!-- Availability Line -->
            <div class="availability-line">
              <strong>Availability:</strong>
              {{ getTotalSlotsCount(dayIndex) }} slots
              <!-- <span class="availability-slots-list">
                <ng-container *ngFor="let slot of generateThirtyMinuteSlots(
                  getWorkSlots(dayIndex).at(0)?.get('start_time')?.value,
                  getWorkSlots(dayIndex).at(0)?.get('end_time')?.value
                ); let i = index; let last = last">
                  <span *ngIf="!isSlotExcluded(slot.start, slot.end, day.get('expert_slots')?.value)">
                    {{ convertTo12Hour(slot.start) }}—{{ convertTo12Hour(slot.end) }}<span *ngIf="!last">, </span>
                  </span>
                </ng-container>
              </span> -->
            </div>

            <!-- Excluded Line (only show if there are excluded slots) -->
            <div class="excluded-line" *ngIf="day.get('expert_slots')?.value?.length > 0">
              <strong>Excluded:</strong>
              {{ day.get('expert_slots')?.value?.length }} slots
              ;
              <span class="excluded-times">
                <span *ngFor="let slot of day.get('expert_slots')?.value; let last = last">
                  {{ convertTo12Hour(slot.start_time) }}—{{ convertTo12Hour(slot.end_time) }}<span *ngIf="!last">, </span>
                </span>
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Non-AAM Save/Cancel at bottom of inner card -->
    <div *ngIf="!isAAM" class="inner-card-save-bar">
      <button type="reset" class="btn btn-default btncancel" (click)="cancelAdditionalInfo()">Cancel</button>
      <button type="submit" class="btn btn-primary btnsave savecls" (click)="saveAdditionalInfo()">Save</button>
    </div>
  </form>
</div>

    <!-- ========================================
         SUBSCRIPTION TAB
         ======================================== -->
    <div class="tab-content-area" *ngIf="activeTab === 'subscription'">
      <div class="subscription-content" *ngIf="subscription_details">
        <div class="subscription-grid">
          <!-- Left Column -->
          <div class="subscription-column">
            <div class="subscription-field">
              <label class="field-label-view">Account Activated on</label>
              <div class="field-value-view">{{subscription_details?.activatedOn || 'N/A'}}</div>
            </div>
            
            <div class="subscription-field">
              <label class="field-label-view">Plan Details</label>
              <div class="field-value-view plan-details">
                <span class="plan-cost" *ngIf="subscription_details?.plan">
                  {{subscription_details?.plan?.name}}
                </span>
              </div>
            </div>
            
            <div class="subscription-field">
              <label class="field-label-view">Plan Validity</label>
              <div class="field-value-view validity-dates">
                <span *ngIf="subscription_details?.startDate && subscription_details?.endDate">
                  {{subscription_details?.startDate}} - {{subscription_details?.endDate}}
                </span>
                <span *ngIf="!subscription_details?.startDate || !subscription_details?.endDate">
                  {{subscription_details?.validityDays || 'N/A'}}
                </span>
              </div>
            </div>
                        
            <div class="subscription-field">
              <label class="field-label-view">T&C Accepted On</label>
              <div class="field-value-view plan-details">
                <span class="plan-cost">
                  {{ basic_profile?.['accepted_t&c_date'] }}
                </span>
              </div>
            </div>
          </div>
          
          <!-- Right Column -->
          <div class="subscription-column">
            <div class="subscription-field">
              <label class="field-label-view">Subscription Start Date</label>
              <div class="field-value-view">{{subscription_details?.startDate || subscription_details?.activatedOn || 'N/A'}}</div>
            </div>
            
            <div class="subscription-field">
              <label class="field-label-view">Mode of Payment</label>
              <div class="field-value-view">
                <span *ngIf="subscription_details?.payment?.method">
                  {{subscription_details?.payment?.method}} 
                  <span *ngIf="subscription_details?.payment?.maskedId">({{subscription_details?.payment?.maskedId}})</span>
                </span>
                <span *ngIf="!subscription_details?.payment?.method">N/A</span>
              </div>
            </div>
            
            <div class="subscription-field">
              <label class="field-label-view">Next Billing Date</label>
              <div class="field-value-view next-billing">
                {{subscription_details?.nextBillingDate || 'N/A'}}
                <button *ngIf="subscription_details?.canPayNow" class="pay-bill-btn" (click)="onPayBill()">Pay Bill</button>
                 <button *ngIf="subscription_details?.canUpgrade" class="pay-bill-btn" (click)="openPlanModal('upgrade')">Upgrade Plan</button>
                  <button *ngIf="subscription_details?.canDowngrade" class="pay-bill-btn" (click)="openPlanModal('downgrade')">Downgrade Plan</button>
              </div>
            </div>
          </div>
        </div>
      <div class="no-content-text" *ngIf="!subscription_details">No subscription details available</div>
    </div>
   </div>

    <!-- ══════════════════════════════════════════
      BANK ACCOUNT DETAILS — bottom info card
      ══════════════════════════════════════════ -->
    <div *ngIf="activeTab === 'settlement'">
    <div class="bank-info-card" *ngIf="bankAccountFetched && !bankAccountDetails">
      <div class="bank-info-icon">
        <i class="bi bi-bank2"></i>
      </div>
      <div class="bank-info-text">
        <h6 class="bank-info-title">Add your bank account details</h6>
        <p class="bank-info-desc">
          Add your bank account details to receive secure payment settlements and faster payouts.
          Your banking information is securely encrypted and used only for payment processing.
        </p>
        <span class="bank-info-secure"><i class="bi bi-lock-fill me-1"></i>Your details are 100% secure</span>
      </div>
      <div class="bank-info-action">
        <button type="button" class="btn btn-primary bank-add-btn" (click)="openBankAccountModal('add')">
          <i class="bi bi-bank2 me-2"></i>Add Bank Account Details
        </button>
      </div>
    </div>

    <div class="bank-info-card bank-info-card--added" *ngIf="bankAccountFetched && bankAccountDetails">
      <div class="bank-info-icon bank-info-icon--added">
        <i class="bi bi-bank2"></i>
        <span class="bank-added-check"><i class="bi bi-check-circle-fill"></i></span>
      </div>
      <div class="bank-info-text">
        <h6 class="bank-info-title">Bank Account Details</h6>
        <p class="bank-info-desc">
          Your bank account has been added successfully and will be used for payment settlements.
        </p>
      </div>
      <div class="bank-info-action">
        <button type="button" class="btn-bank-outline-primary bank-manage-btn" (click)="openBankAccountModal('view')">
          <i class="bi bi-bank2 me-2"></i>View / Manage Bank Details
        </button>
      </div>
    </div>
    </div>

      </div>

</ng-container>
<!-- ═══════════════════════════════  ═══════════════════════════
     PLAN MODAL (Upgrade / Downgrade)
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showPlanModal" (click)="closePlanModal()"></div>
<div class="modal-panel modal-plan" *ngIf="showPlanModal">

  <div class="modal-header"
       [class.modal-header-upgrade]="planModalMode === 'upgrade'"
       [class.modal-header-downgrade]="planModalMode === 'downgrade'">
    <h6 class="modal-title">
      <i class="bi me-2"
         [class.bi-arrow-up-circle]="planModalMode === 'upgrade'"
         [class.bi-arrow-down-circle]="planModalMode === 'downgrade'"></i>
      {{ planModalMode === 'upgrade' ? 'Upgrade Plan' : 'Downgrade Plan' }}
    </h6>
    <button class="modal-close-btn" (click)="closePlanModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Loading skeleton -->
  <div class="modal-body" *ngIf="planModalLoading">
    <div class="plan-skeleton">
      <div class="plan-sk-row"></div>
      <div class="plan-sk-row wide"></div>
      <div class="plan-sk-row wide"></div>
      <div class="plan-sk-row"></div>
    </div>
  </div>

  <!-- Content -->
  <div class="modal-body" *ngIf="!planModalLoading && planModalData">

    <!-- Current plan banner -->
    <div class="current-plan-banner">
      <span class="cp-label">Current Plan</span>
      <span class="cp-name">{{ planModalData.current_plan?.name }}</span>
      <span class="cp-price">
        {{ planModalData.current_plan?.currency }}
        {{ planModalData.current_plan?.price | number:'1.0-0' }}/mo
      </span>
      <span class="cp-status"
            [class.cp-status--active]="planModalData.sub_status === 'active'"
            [class.cp-status--inactive]="planModalData.sub_status !== 'active'">
        {{ planModalData.sub_status | titlecase }}
      </span>
    </div>

    <!-- No options -->
    <div class="no-plan-options" *ngIf="planOptions.length === 0">
      <i class="bi bi-info-circle me-2"></i>
      No {{ planModalMode }} options available for this account.
    </div>

    <!-- Plan option cards -->
    <div class="plan-options-list" *ngIf="planOptions.length > 0">
      <label class="plan-option-card"
             *ngFor="let opt of planOptions"
             [class.plan-option-card--selected]="selectedPlanKey === opt.key"
             (click)="selectedPlanKey = opt.key">
        <input type="radio" name="planChoice" [value]="opt.key"
               [(ngModel)]="selectedPlanKey" style="display:none">
        <div class="poc-left">
          <div class="poc-radio">
            <i class="bi"
               [class.bi-record-circle-fill]="selectedPlanKey === opt.key"
               [class.bi-circle]="selectedPlanKey !== opt.key"></i>
          </div>
          <div class="poc-info">
            <span class="poc-name">{{ opt.name }}</span>
            <span class="poc-label">{{ opt.pricing?.label }}</span>
          </div>
        </div>
        <div class="poc-price">
          <span class="poc-amount">{{ opt.currency }} {{ opt.price | number:'1.0-0' }}</span>
          <span class="poc-period">/mo</span>
        </div>
      </label>
    </div>

    <!-- Pricing summary — UPGRADE -->
    <div class="pricing-summary"
         *ngIf="planModalMode === 'upgrade' && selectedPlanKey && getSelectedPlanPricing() as pricing">
      <div class="ps-row">
        <span>Remaining value on current plan</span>
        <span>{{ pricing.currency }} {{ pricing.remaining_value | number:'1.2-2' }}</span>
      </div>
      <div class="ps-row">
        <span>Remaining days</span>
        <span>{{ pricing.remaining_days }} days</span>
      </div>
      <div class="ps-row ps-highlight">
        <span>Amount due now</span>
        <strong>{{ pricing.currency }} {{ pricing.adjustment_amount | number:'1.2-2' }}</strong>
      </div>
      <p class="ps-note">
        <i class="bi bi-envelope me-1"></i>
        A payment link will be sent to <strong>{{ planModalData.email }}</strong>
      </p>
    </div>

    <!-- Pricing summary — DOWNGRADE -->
    <div class="pricing-summary pricing-summary--downgrade"
         *ngIf="planModalMode === 'downgrade' && selectedPlanKey && getSelectedPlanPricing() as pricing">
      <div class="ps-row">
        <span>Monthly saving</span>
        <span class="ps-saving">{{ pricing.currency }} {{ pricing.saving | number:'1.2-2' }}/mo</span>
      </div>
      <div class="ps-row">
        <span>Effective date</span>
        <span>{{ pricing.effective_date }}</span>
      </div>
      <p class="ps-note ps-note--warning">
        <i class="bi bi-clock-history me-1"></i>
         After submitting your request, our team will review it. Your current subscription will continue until the downgrade is approved and becomes effective.
      </p>
    </div>

    <!-- Downgrade reason -->
    <div class="form-group downgrade-reason-wrap"
         *ngIf="planModalMode === 'downgrade' && planOptions.length > 0">
      <label class="form-label">
        Reason for Downgrade <span class="req">*</span>
      </label>
      <textarea class="form-control" rows="3"
                placeholder="Enter the Reason"
                [(ngModel)]="downgradeReason"
                (ngModelChange)="downgradeReasonError = ''"
                [class.is-invalid]="downgradeReasonError">
      </textarea>
      <div class="field-error" *ngIf="downgradeReasonError">{{ downgradeReasonError }}</div>
    </div>

  </div>

  <div class="modal-footer" *ngIf="!planModalLoading">
    <button class="btn btn-cancel" (click)="closePlanModal()" [disabled]="isPlanSubmitting">
      Cancel
    </button>
    <button class="btn"
            [class.btn-upgrade]="planModalMode === 'upgrade'"
            [class.btn-downgrade]="planModalMode === 'downgrade'"
            (click)="submitPlanChange()"
            [disabled]="isPlanSubmitting || planOptions.length === 0 || !selectedPlanKey">
      <span *ngIf="isPlanSubmitting" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isPlanSubmitting" class="bi me-1"
         [class.bi-arrow-up-circle]="planModalMode === 'upgrade'"
         [class.bi-arrow-down-circle]="planModalMode === 'downgrade'"></i>
      {{ isPlanSubmitting
          ? 'Processing...'
          : (planModalMode === 'upgrade' ? 'Confirm Upgrade' : 'Submit Downgrade') }}
    </button>
  </div>

</div>
</div>
<!-- ══════════════════════════════════════════════════════════
     BANK ACCOUNT DETAILS MODAL
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showBankAccountModal" (click)="requestCloseBankAccountModal()"></div>
<div class="modal-panel modal-bank" *ngIf="showBankAccountModal" role="dialog" aria-modal="true" aria-labelledby="bankModalTitle">

  <form [formGroup]="bankAccountForm" (ngSubmit)="submitBankAccountDetails()"
        (keydown.enter)="blockEnterOnInput($event)" autocomplete="off">

    <div class="modal-header">
      <h6 class="modal-title" id="bankModalTitle">
        <i class="bi bi-bank2 me-2"></i>Bank Account Details
      </h6>
      <button type="button" class="modal-close-btn" (click)="requestCloseBankAccountModal()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">

      <!-- ═══════════ VIEW MODE — read-only, masked ═══════════ -->
      <div class="form-grid" *ngIf="bankAccountModalMode === 'view'">
        <div class="form-group">
          <label class="form-label">Account Holder Name</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.account_holder_name || ''" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">Bank Name</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.bank_name || ''" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">Account Number</label>
          <input type="text" class="form-control" [value]="maskedBankAccountNumber" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">IFSC Code</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.ifsc_code || ''" disabled readonly>
        </div>
        <div class="form-group">
          <label class="form-label">Branch Name</label>
          <input type="text" class="form-control" [value]="bankAccountDetails?.branch_name || ''" disabled readonly>
        </div>
      </div>

      <div class="bank-verified-chip-row" *ngIf="bankAccountModalMode === 'view' && bankAccountDetails?.is_verified !== false">
        <span class="bank-verified-chip"><i class="bi bi-check-circle-fill me-1"></i>Verified</span>
        <span class="bank-verified-date" *ngIf="bankAccountDetails?.verified_on || bankAccountDetails?.verified_at">
          Account verified on {{ bankAccountDetails?.verified_on || bankAccountDetails?.verified_at }}
        </span>
      </div>

      <!-- ═══════════ ADD / EDIT MODE — editable form (unchanged Add flow) ═══════════ -->
      <div class="form-grid" *ngIf="bankAccountModalMode !== 'view'">

        <!-- Row 1: Account Holder Name / Bank Name -->
        <div class="form-group">
          <label class="form-label" for="bankAccountHolderName">Account Holder Name <span class="req">*</span></label>
          <input id="bankAccountHolderName" type="text" class="form-control"
                 [class.is-invalid]="bankAccountForm.get('account_holder_name')?.invalid && bankAccountForm.get('account_holder_name')?.touched"
                 formControlName="account_holder_name" placeholder="Enter account holder name" maxlength="100" autocomplete="off"
                 (blur)="bankAccountForm.get('account_holder_name')?.setValue((bankAccountForm.get('account_holder_name')?.value || '').trim())">
          <div class="field-error" *ngIf="bankAccountForm.get('account_holder_name')?.invalid && bankAccountForm.get('account_holder_name')?.touched">
            <span *ngIf="bankAccountForm.get('account_holder_name')?.errors?.['required']">Account Holder Name is required.</span>
            <span *ngIf="!bankAccountForm.get('account_holder_name')?.errors?.['required']">Enter a valid account holder name.</span>
          </div>
        </div>

        <!-- <div class="form-group">
          <label class="form-label" for="bankName">Bank Name <span class="req">*</span></label>
          <input id="bankName" type="text" class="form-control bnkname" name="bank_name_input" (focus)="enableBankNameInput($event)"
                 [class.is-invalid]="bankAccountForm.get('bank_name')?.invalid && bankAccountForm.get('bank_name')?.touched"
                 formControlName="bank_name" placeholder="Enter bank name" maxlength="100" autocomplete="new-password"
                 (blur)="bankAccountForm.get('bank_name')?.setValue((bankAccountForm.get('bank_name')?.value || '').trim())">
          <div class="field-error" *ngIf="bankAccountForm.get('bank_name')?.invalid && bankAccountForm.get('bank_name')?.touched">
            <span *ngIf="bankAccountForm.get('bank_name')?.errors?.['required']">Bank Name is required.</span>
            <span *ngIf="!bankAccountForm.get('bank_name')?.errors?.['required']">Enter a valid bank name.</span>
          </div>
        </div> -->
        <div class="form-group">
          <label class="form-label" for="bankName">
            Bank Name <span class="req">*</span>
          </label>
        
          <input id="bankName" name="bank_name_input" type="text" class="form-control bnkname" formControlName="bank_name"
            placeholder="Enter bank name" maxlength="100" autocomplete="new-password"
            (focus)="enableBankNameInput($event)" (blur)="bankAccountForm.get('bank_name')?.setValue(
              (bankAccountForm.get('bank_name')?.value || '').trim()
            )" [class.is-invalid]="
              bankAccountForm.get('bank_name')?.invalid &&
              bankAccountForm.get('bank_name')?.touched
            ">
        
          <div class="field-error" *ngIf="
              bankAccountForm.get('bank_name')?.invalid &&
              bankAccountForm.get('bank_name')?.touched
            ">
            <span *ngIf="bankAccountForm.get('bank_name')?.errors?.['required']">
              Bank Name is required.
            </span>
        
            <span *ngIf="!bankAccountForm.get('bank_name')?.errors?.['required']">
              Enter a valid bank name.
            </span>
          </div>
        </div>


        <!-- Row 2: Account Number / Confirm Account Number -->
        <!-- <div class="form-group">
          <label class="form-label" for="bankAccountNumber">Account Number<span class="req">*</span></label>
          <div class="input-with-icon">
            <input id="bankAccountNumber" [type]="showAccountNumber ? 'text' : 'password'" class="form-control"
                   [class.is-invalid]="bankAccountForm.get('account_number')?.invalid && bankAccountForm.get('account_number')?.touched"
                   formControlName="account_number" placeholder="Enter account number" maxlength="18" inputmode="numeric" autocomplete="off"
                   (input)="sanitizeNumericInput('account_number')">
            <button type="button" class="input-icon-btn" (click)="toggleAccountNumberVisibility()"
                    [attr.aria-label]="showAccountNumber ? 'Hide account number' : 'Show account number'">
              <i class="bi" [class.bi-eye-slash]="!showAccountNumber" [class.bi-eye]="showAccountNumber"></i>
            </button>
          </div>
          <div class="field-error" *ngIf="bankAccountForm.get('account_number')?.invalid && bankAccountForm.get('account_number')?.touched">
            <span *ngIf="bankAccountForm.get('account_number')?.errors?.['required']">Account Number is required.</span>
            <span *ngIf="!bankAccountForm.get('account_number')?.errors?.['required']">Enter a valid account number.</span>
          </div>
        </div> -->

        <div class="form-group">
          <label class="form-label" for="bankAccountNumber">
            Account Number <span class="req">*</span>
          </label>
        
          <div class="input-with-icon">
            <input id="bankAccountNumber" name="bank_account_number_input" type="text" class="form-control account-number-input bnkname"
              formControlName="account_number" placeholder="Enter account number" maxlength="18" inputmode="numeric"
              autocomplete="new-password" [readonly]="bankAccountModalMode !== 'edit'" [class.account-number-masked]="!showAccountNumber" [class.is-invalid]="
                bankAccountForm.get('account_number')?.invalid &&
                bankAccountForm.get('account_number')?.touched" 
                (focus)="enableAccountNumberInput($event)" (input)="sanitizeNumericInput('account_number')">
        
            <button type="button" class="input-icon-btn" (click)="toggleAccountNumberVisibility()" [attr.aria-label]="
                showAccountNumber
                  ? 'Hide account number'
                  : 'Show account number'
              ">
              <i class="bi" [class.bi-eye-slash]="!showAccountNumber" [class.bi-eye]="showAccountNumber"></i>
            </button>
          </div>
        
          <div class="field-error" *ngIf="
              bankAccountForm.get('account_number')?.invalid &&
              bankAccountForm.get('account_number')?.touched
            ">
            <span *ngIf="bankAccountForm.get('account_number')?.errors?.['required']">
              Account Number is required.
            </span>
        
            <span *ngIf="!bankAccountForm.get('account_number')?.errors?.['required']">
              Enter a valid account number.
            </span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="bankConfirmAccountNumber">Confirm Account Number <span class="req">*</span></label>
          <div class="input-with-icon">
            <input id="bankConfirmAccountNumber" name="bank_confirm_account_number_input" [type]="showConfirmAccountNumber ? 'text' : 'password'" class="form-control bnkname"
                   [class.is-invalid]="bankAccountForm.hasError('accountNumberMismatch') || (bankAccountForm.get('confirm_account_number')?.invalid && (bankAccountForm.get('confirm_account_number')?.touched || bankAccountForm.get('confirm_account_number')?.dirty))"
                   formControlName="confirm_account_number" placeholder="Re-enter account number" maxlength="18" inputmode="numeric" autocomplete="new-password"
                   [readonly]="bankAccountModalMode !== 'edit'"
                   (focus)="enableConfirmAccountNumberInput($event)" (input)="sanitizeNumericInput('confirm_account_number')">
            <button type="button" class="input-icon-btn" (click)="toggleConfirmAccountNumberVisibility()"
                    [attr.aria-label]="showConfirmAccountNumber ? 'Hide account number' : 'Show account number'">
              <i class="bi" [class.bi-eye-slash]="!showConfirmAccountNumber" [class.bi-eye]="showConfirmAccountNumber"></i>
            </button>
            <i class="bi bi-check-circle-fill input-verified-tick"
               *ngIf="bankAccountForm.get('confirm_account_number')?.value && !bankAccountForm.hasError('accountNumberMismatch') && bankAccountForm.get('confirm_account_number')?.valid"></i>
          </div>
          <!-- <div class="field-error" *ngIf="bankAccountForm.get('confirm_account_number')?.touched && bankAccountForm.hasError('accountNumberMismatch')">
            Account numbers do not match.
          </div> -->
          <div class="field-error" *ngIf="bankAccountForm.hasError('accountNumberMismatch') &&
            (bankAccountForm.get('confirm_account_number')?.touched || bankAccountForm.get('confirm_account_number')?.dirty)">
            Account numbers do not match.
          </div>
          <div class="field-error" *ngIf="bankAccountForm.get('confirm_account_number')?.touched && !bankAccountForm.hasError('accountNumberMismatch') && bankAccountForm.get('confirm_account_number')?.errors?.['required']">
            Account Number is required.
          </div>
        </div>

        <!-- Row 3: IFSC Code / Branch Name -->
        <div class="form-group">
          <label class="form-label" for="bankIfscCode">IFSC Code <span class="req">*</span></label>
          <input id="bankIfscCode" type="text" class="form-control"
                 [class.is-invalid]="bankAccountForm.get('ifsc_code')?.invalid && bankAccountForm.get('ifsc_code')?.touched"
                 formControlName="ifsc_code" placeholder="Enter IFSC code (e.g. SBIN0001234)" maxlength="11"
                 style="text-transform:uppercase;">
          <div class="field-error" *ngIf="bankAccountForm.get('ifsc_code')?.invalid && bankAccountForm.get('ifsc_code')?.touched">
            Enter a valid IFSC Code.
          </div>

          <!-- Verify action, aligned with the IFSC field -->
          <div class="bank-verify-row">
            <button type="button" class="btn-verify-outline bank-verify-btn"
                    [disabled]="!canVerifyBankAccount"
                    (click)="verifyBankAccount()">
              <span *ngIf="isBankAccountVerifying" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!isBankAccountVerifying" class="bi bi-shield-check me-1"></i>
              {{ isBankAccountVerifying ? 'Verifying...' : 'Verify' }}
            </button>
            <button type="button" class="bank-edit-link" *ngIf="isBankFieldsLocked" (click)="unlockBankFieldsForEdit()">
              <i class="bi bi-pencil-fill me-1"></i>Edit
            </button>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="bankBranchName">
            Branch Name
            <i class="bi bi-info-circle branch-tooltip-icon"
               matTooltip="Branch Name will be automatically fetched after successful verification using the IFSC Code."
               matTooltipPosition="above"></i>
          </label>
          <input id="bankBranchName" type="text" class="form-control" formControlName="branch_name"
                 placeholder="Will appear after verification"
                 matTooltip="Branch Name will be automatically fetched after successful verification using the IFSC Code."
                 [matTooltipDisabled]="!bankAccountForm.get('branch_name')?.disabled"
                 matTooltipPosition="above">
        </div>

      </div>

      <!-- Verification status banners (Add / Edit only) -->
      <div class="bank-status-banner bank-status-banner--success" *ngIf="bankAccountModalMode !== 'view' && isBankAccountVerified">
        <i class="bi bi-check-circle-fill me-2"></i>Bank account verified successfully.
      </div>
      <div class="bank-status-banner bank-status-banner--error" *ngIf="bankAccountModalMode !== 'view' && bankVerifyError">
        <i class="bi bi-exclamation-circle-fill me-2"></i>{{ bankVerifyError }}
      </div>

      <!-- Terms & Conditions (Add / Edit only) -->
      <label class="bank-terms-row" *ngIf="bankAccountModalMode !== 'view'">
        <input type="checkbox" class="bank-terms-checkbox" [(ngModel)]="bankTermsAccepted" [ngModelOptions]="{standalone: true}">
        <span>
          I have read and agree to the <a href="https://digicoffer.com/digicoffer_terms.pdf" target="_blank" rel="noopener">Terms &amp; Conditions</a>
          and <a href="https://digicoffer.com/digicoffer_privacy.pdf" target="_blank" rel="noopener">Privacy Policy</a>, and I authorize <a href="https://lexiz.ai/" target="_blank" rel="noopener">LexiZ.ai</a> to securely
          verify, process, and store my bank account details for payment settlements in accordance with applicable regulations.
        </span>
      </label>

    </div>

    <!-- VIEW MODE footer: Close / Edit Bank Details -->
    <div class="modal-footer" *ngIf="bankAccountModalMode === 'view'">
      <button type="button" class="btn btn-cancel" (click)="closeBankAccountModal()">
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="switchToEditMode()">
        <i class="bi bi-pencil-fill me-2"></i>Edit Bank Details
      </button>
    </div>

    <!-- ADD / EDIT MODE footer: Cancel / Submit or Save Changes -->
    <div class="modal-footer" *ngIf="bankAccountModalMode !== 'view'">
      <button type="button" class="btn btn-cancel" (click)="requestCloseBankAccountModal()" [disabled]="isBankAccountSubmitting">
        Cancel
      </button>
      <span class="bank-submit-tooltip-wrap"
            [attr.title]="!isBankSubmitEnabled ? 'Complete bank verification and accept the Terms &amp; Conditions to enable submission.' : null">
        <button type="submit" class="btn btn-primary" [disabled]="!isBankSubmitEnabled">
          <span *ngIf="isBankAccountSubmitting" class="spinner-border spinner-border-sm me-1"></span>
          {{ isBankAccountSubmitting ? (bankAccountModalMode === 'edit' ? 'Saving...' : 'Submitting...') : (bankAccountModalMode === 'edit' ? 'Save Changes' : 'Submit') }}
        </button>
      </span>
    </div>

  </form>
</div>

<!-- ───── Discard bank account changes confirmation dialog (reuses wa-confirm-*) ───── -->
<div class="wa-confirm-overlay"
     *ngIf="showBankDiscardConfirm"
     role="dialog"
     aria-modal="true"
     aria-labelledby="bankDiscardConfirmTitle">

  <div class="wa-confirm-dialog_rs">

    <!-- Close Icon -->
    <button
      type="button"
      class="wa-confirm-close_rs"
      aria-label="Close"
      (click)="keepEditingBankAccount()">
      <i class="fa fa-times"></i>
    </button>

    <h4 class="wa-confirm-title" id="bankDiscardConfirmTitle">
      Discard your changes?
    </h4>

    <p class="wa-confirm-message">
      Your unsaved changes will be lost.
    </p>

    <div class="wa-confirm-actions_rs">
      <button
        type="button"
        class="wa-btn-cancel_rs"
        (click)="keepEditingBankAccount()">
        Keep Editing
      </button>

      <button
        type="button"
        class="wa-btn-remove_rs"
        (click)="confirmDiscardBankChanges()">
        Discard
      </button>
    </div>

  </div>
</div>

<router-outlet></router-outlet>
<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>